import type { Translations } from './types';

export const es: Translations = {
  // Common
  'common.loading': 'Cargando…',
  'common.prev': 'Ant.',
  'common.next': 'Sig.',
  'common.cancel': 'Cancelar',
  'common.back': 'Atrás',
  'common.search': 'Buscar',
  'common.close': 'Cerrar',
  'common.exit': 'Salir',
  'common.noData': 'Sin datos',
  'common.failedToLoad': 'Error al cargar',
  'common.retry': 'Reintentar',
  'common.reloadPage': 'Recargar página',
  'common.beta': 'Beta',

  // Auth
  'auth.subtitle': 'Plataforma de telemetría de karting',
  'auth.signInDescription': 'Inicia sesión para acceder a los datos de telemetría.',
  'auth.signInWithGoogle': 'Iniciar sesión con Google',
  'auth.signInWithApple': 'Iniciar sesión con Apple',
  'auth.or': 'o',
  'auth.signingIn': 'Iniciando sesión…',
  'auth.signOut': 'Cerrar sesión',

  // OAuth Consent
  'oauth.authorizeTitle': 'Autorizar a {name}',
  'oauth.authorizeSubtitle': '{name} quiere acceder a tu cuenta de telemetría de kart.win.',
  'oauth.permissionsTitle': 'Permisos solicitados',
  'oauth.permSessions': 'Leer todas las sesiones, vueltas y canales de telemetría',
  'oauth.permAnalysis': 'Leer métricas calculadas y comparaciones',
  'oauth.permSetups': 'Leer reglajes del kart y configuraciones de circuito',
  'oauth.signedIn': 'Sesión iniciada',
  'oauth.mustSignInFirst': 'Inicia sesión para autorizar esta aplicación',
  'oauth.authorizeButton': 'Autorizar aplicación',
  'oauth.missingParams': 'Faltan parámetros de autorización OAuth obligatorios',

  // Settings
  'settings.title': 'Ajustes',
  'settings.account': 'Cuenta',
  'settings.profile': 'Perfil',
  'settings.displayName': 'Nombre visible',
  'settings.saveName': 'Guardar nombre',
  'settings.nameSaved': 'Nombre actualizado correctamente',
  'settings.linkedAccounts': 'Cuentas vinculadas',
  'settings.linkGoogle': 'Vincular cuenta de Google',
  'settings.linkApple': 'Vincular cuenta de Apple',
  'settings.unlink': 'Desvincular',
  'settings.linked': 'Vinculada',
  'settings.notLinked': 'No vinculada',
  'settings.cannotUnlinkOnlyProvider': 'Debe permanecer vinculado al menos un método de inicio de sesión.',
  'settings.language': 'Idioma',
  'settings.userId': 'ID de usuario',
  'settings.signOut': 'Cerrar sesión',
  'settings.connectedApps': 'Aplicaciones conectadas',
  'settings.connectedAppsDesc': 'Gestiona asistentes de IA, IDEs y herramientas autorizadas para acceder a tus datos de telemetría mediante MCP.',
  'settings.noConnectedApps': 'Aún no hay aplicaciones conectadas. Autoriza un cliente MCP (como Claude Desktop o Cursor) para verlo aquí.',
  'settings.authorizedOn': 'Autorizado',
  'settings.lastUsed': 'Último uso',
  'settings.neverUsed': 'Nunca',
  'settings.revoke': 'Revocar',
  'settings.revokeAppConfirm': '¿Seguro que quieres revocar el acceso de esta aplicación? Todas las sesiones activas dejarán de funcionar inmediatamente.',
  'settings.appRevokedSuccess': 'Acceso de la aplicación revocado correctamente',
  'settings.copyKey': 'Copiar fragmento',
  'settings.keyCopied': 'Copiado al portapapeles',
  'settings.mcpConfigSnippet': 'Configuración del cliente MCP',
  'settings.mcpConfigDesc': 'Añade esta configuración a los ajustes MCP de Claude Desktop (claude_desktop_config.json) o Cursor. La autenticación se completará automáticamente a través de tu navegador:',
  'settings.deleteAccount': 'Eliminar cuenta',
  'settings.deleteAccountDesc': 'Elimina permanentemente tu cuenta y todas las sesiones, datos de telemetría, análisis guardados, equipamiento, setups de kart y elementos compartidos asociados.',
  'settings.deleteAccountConfirmTitle': '¿Eliminar cuenta permanentemente?',
  'settings.deleteAccountConfirmDesc': 'Esta acción no se puede deshacer. Todas tus sesiones, datos de telemetría, análisis guardados, equipamiento, setups de kart, equipos y sesiones compartidas se eliminarán de forma inmediata y permanente.',
  'settings.deleteAccountConfirmPrompt': 'Para confirmar, escribe «{phrase}» en el cuadro de abajo:',
  'settings.deleteAccountConfirmPhrase': 'eliminar mi cuenta',
  'settings.deleteAccountConfirmButton': 'Eliminar mi cuenta',

  // Dashboard
  'dashboard.overview': 'Resumen',
  'dashboard.subtitle': 'Telemetría y datos de vueltas',
  'dashboard.recentSessions': 'Sesiones recientes',
  'dashboard.total': '{n} en total',
  'dashboard.failedToLoadDashboard': 'Error al cargar el panel',
  'dashboard.noDataAvailable': 'No hay datos disponibles',

  // Stats
  'stats.sessions': 'Sesiones',
  'stats.laps': 'Vueltas',
  'stats.trackTime': 'Tiempo en pista',
  'stats.tracks': 'Circuitos',

  // Search
  'search.placeholder': 'Buscar sesiones… (p. ej. name:WOHLEN laps:>=5)',
  'search.button': 'Buscar',
  'search.syntaxHelp': 'Ayuda de sintaxis de búsqueda',
  'search.title': 'Sintaxis de búsqueda',
  'search.subtitle': 'Filtra sesiones usando pares campo:valor. Varios términos se combinan con AND.',
  'search.closeDialog': 'Cerrar diálogo',
  'search.operatorsTitle': 'Operadores y lógica',
  'search.examplesTitle': 'Ejemplos de consultas',
  'search.numericComparisons': 'Comparaciones numéricas:',
  'search.range': 'Rango:',
  'search.rangeDesc': '— coincide con valores entre 5 y 20 inclusive.',
  'search.booleanLogic': 'Lógica booleana:',
  'search.booleanLogicDesc': 'Los términos se unen implícitamente con',
  'search.quotes': 'Comillas:',
  'search.quotesDesc': 'Envuelve los valores con espacios entre comillas dobles, p. ej.',

  // Filter UI
  'filter.add': 'Añadir filtro',
  'filter.allActive': 'Todos los filtros activos',
  'filter.clearAll': 'Borrar todo',
  'filter.clear': 'Borrar',
  'filter.apply': 'Aplicar',
  'filter.cancel': 'Cancelar',
  'filter.condition': 'Condición',
  'filter.presets': 'Preajustes',
  'filter.customRange': 'Rango personalizado',
  'filter.from': 'Desde',
  'filter.to': 'Hasta',
  'filter.min': 'Mín.',
  'filter.max': 'Máx.',
  'filter.value': 'Valor',
  'filter.searchOptions': 'Buscar opciones...',
  'filter.noOptions': 'No se encontraron opciones',
  'filter.loadingOptions': 'Cargando opciones...',

  // Search fields
  'search.field.bareText': '(texto libre)',
  'search.field.bareTextDesc': 'Coincide con el nombre del circuito o del piloto que contenga el texto.',
  'search.field.name': 'name',
  'search.field.nameDesc': 'Coincide con el nombre del circuito o del piloto que contenga el valor.',
  'search.field.driver': 'driver',
  'search.field.driverDesc': 'Coincide con el nombre del piloto que contenga el valor.',
  'search.field.laps': 'laps',
  'search.field.lapsDesc': 'Filtra por número de vueltas completadas. Admite =, >, >=, <, <= y rangos.',
  'search.field.temp': 'temp',
  'search.field.tempDesc': 'Filtra por temperatura ambiente (°C). Admite operadores de comparación y rangos.',
  'search.field.season': 'season',
  'search.field.seasonDesc': 'Filtra por año de temporada (extraído de la fecha de la sesión). Admite operadores de comparación.',
  'search.field.from': 'from',
  'search.field.fromDesc': 'Sesiones en o después de una fecha. Acepta YYYY-MM-DD o relativas: -7d, -2w, -3m, -1y.',
  'search.field.to': 'to',
  'search.field.toDesc': 'Sesiones en o antes de una fecha. Mismos formatos que "from".',

  // Search examples
  'search.example.wohlenLaps': 'Sesiones en Wohlen con 5+ vueltas',
  'search.example.yanick30d': 'Sesiones de Yanick de los últimos 30 días',
  'search.example.tempLaps': 'Sesiones entre 15–25 °C con 3+ vueltas',
  'search.example.wohlenMagny': 'Sesiones en Wohlen o Magny del último año',

  // Session list
  'sessionList.date': 'Fecha',
  'sessionList.time': 'Hora',
  'sessionList.track': 'Circuito',
  'sessionList.sessions': 'Sesiones',
  'sessionList.driver': 'Piloto',
  'sessionList.laps': 'Vueltas',
  'sessionList.best': 'Mejor',
  'sessionList.weather': 'Clima',
  'sessionList.lapsUnit': '{n} vueltas',
  'sessionList.sessionCount': '{count} sesiones',
  'sessionList.sessionCountSingular': '1 sesión',
  'sessionList.noSessions': 'No se encontraron sesiones. Prueba con otra búsqueda.',

  // Track bests
  'trackBests.title': 'Récords de circuito',

  // Session detail
  'session.title': 'Sesión',
  'session.failedToLoad': 'Error al cargar la sesión',
  'session.noData': 'Sin datos de sesión',
  'session.chipOverview': 'Resumen',
  'session.chipDiff': 'Dif.',
  'session.tabWeather': 'Clima',
  'session.tabLaps': 'Vueltas',
  'session.tabSetup': 'Setup',
  'session.tabManage': 'Gestionar',
  'session.dangerZone': 'Zona de peligro',
  'session.deleteDescription': 'Elimina permanentemente esta sesión, todas las vueltas registradas y los datos de telemetría. Esta acción no se puede deshacer.',
  'session.delete': 'Eliminar sesión',
  'session.deleteConfirmTitle': 'Eliminar sesión',
  'session.deleteConfirmMessage': '¿Seguro que quieres eliminar esta sesión? Esta acción no se puede deshacer y eliminará permanentemente todos los datos de vueltas y telemetría.',
  'session.deleteSuccess': 'Sesión eliminada correctamente',
  'session.deleteFailed': 'Error al eliminar la sesión',
  'session.deleting': 'Eliminando sesión...',

  // Session meta
  'sessionMeta.date': 'Fecha',
  'sessionMeta.driver': 'Piloto',
  'sessionMeta.track': 'Circuito',
  'sessionMeta.laps': 'Vueltas',
  'sessionMeta.device': 'Dispositivo',
  'sessionMeta.status': 'Estado',
  'sessionMeta.tyres': 'Neumáticos',
  'sessionMeta.tyreAge': '{n} vueltas',
  'sessionMeta.fresh': 'Nuevos',

  // Weather
  'weather.wind': 'Viento',
  'weather.humidity': 'Humedad',
  'weather.cloudCover': 'Nubosidad',
  'weather.precipitation': 'Precipitación',
  'weather.pressure': 'Presión',
  'weather.feels': 'Sensación',
  'weather.clear': 'Despejado',
  'weather.partlyCloudy': 'Parcialmente nublado',
  'weather.overcast': 'Cubierto',
  'weather.fog': 'Niebla',
  'weather.drizzle': 'Llovizna',
  'weather.rain': 'Lluvia',
  'weather.freezingRain': 'Lluvia engelante',
  'weather.snow': 'Nieve',
  'weather.rainShowers': 'Chubascos',
  'weather.snowShowers': 'Chubascos de nieve',
  'weather.thunderstorm': 'Tormenta',
  'weather.unknown': 'Desconocido',

  // Lap table
  'lapTable.title': 'Tiempos por vuelta',
  'lapTable.theoLap': 'Vuelta rápida',
  'lapTable.aggregation': 'Agregación',
  'lapTable.compare': 'Comparar',
  'lapTable.lapTime': 'Tiempo de vuelta',
  'lapTable.delta': 'Delta',
  'lapTable.maxRpm': 'RPM máx.',
  'lapTable.minRpm': 'RPM mín.',
  'lapTable.maxSpeed': 'Vel. máx.',
  'lapTable.minSpeed': 'Vel. mín.',
  'lapTable.tyreAge': 'Uso neum.',

  // Diff chart
  'diffChart.outlierLap': 'Atípica',
  'diffChart.deltaToBest': 'Delta respecto a la mejor',

  // Lap analysis
  'lapAnalysis.title': 'Análisis de la vuelta {n}',
  'lapAnalysis.resetZoom': 'Restablecer zoom',
  'lapAnalysis.speed': 'Velocidad',
  'lapAnalysis.acceleration': 'Aceleración',
  'lapAnalysis.rpm': 'RPM',
  'lapAnalysis.gForce': 'Fuerza G',
  'lapAnalysis.trackMap': 'Mapa del circuito',
  'lapAnalysis.failedToLoad': 'Error al cargar la telemetría',
  'lapAnalysis.noTelemetry': 'No hay datos de telemetría para esta vuelta.',

  // Lap info
  'lapInfo.lapTime': 'Tiempo de vuelta',
  'lapInfo.maxRpm': 'RPM máx.',
  'lapInfo.minRpm': 'RPM mín.',
  'lapInfo.maxSpeed': 'Vel. máx.',
  'lapInfo.maxTemp': 'Temp. máx.',
  'lapInfo.gpsOffset': 'Desfase GPS',
  'lapInfo.gpsOffsetTooltip': 'Deriva GPS corregida: {east} E, {north} N',

  // Navigation
  'nav.data': 'Datos',
  'nav.home': 'Sesiones',
  'nav.tools': 'Herramientas',
  'nav.compare': 'Comparar',
  'nav.drivers': 'Pilotos',
  'nav.tracks': 'Circuitos',
  'nav.settings': 'Ajustes',

  // Analysis
  'analysis.title': 'Herramientas de análisis',
  'analysis.subtitle': 'Profundiza en tus datos de telemetría con herramientas de análisis especializadas.',
  'analysis.sector.title': 'Análisis de sectores',
  'analysis.sector.desc': 'Compara sectores de vuelta entre múltiples sesiones para encontrar mejores vueltas teóricas y analizar la consistencia.',


  // Braking Analysis
  'analysis.braking.title': 'Análisis de frenada',
  'analysis.braking.desc': 'Analiza puntos de frenada, zonas de desaceleración, círculos de fricción G-G y eficiencia de trail-braking.',
  'braking.title': 'Análisis de frenada',
  'braking.desc': 'Analiza puntos de frenada, zonas de desaceleración, círculos de fricción G-G y eficiencia de trail-braking.',
  'braking.wizardChooseTrack': 'Elegir circuito',
  'braking.wizardSelect': 'Seleccionar sesiones',
  'braking.wizardResults': 'Resultados',
  'braking.noTracksWithCorners': 'No hay circuitos con trazado y curvas configuradas disponibles.',
  'braking.noSessionsForTrack': 'No se encontraron sesiones para el circuito',
  'braking.noBrakingZones': 'No se detectaron zonas de frenada para este circuito.',
  'braking.selectZone': 'Seleccionar zona de frenada',
  'braking.zone': 'Zona de frenada',
  'braking.zones': 'Zonas de frenada',
  'braking.brakePoint': 'Punto de frenada',
  'braking.apex': 'Vértice',
  'braking.exit': 'Salida',
  'braking.distance': 'Distancia de frenada',
  'braking.duration': 'Duración de frenada',
  'braking.initialSpeed': 'Velocidad inicial',
  'braking.apexSpeed': 'Vel. mín.',
  'braking.minSpeed': 'Vel. mín.',
  'braking.brakeRelease': 'Suelta de freno',
  'braking.exitSpeed': 'Velocidad de salida',
  'braking.speedDrop': 'Caída de velocidad',
  'braking.peakDecel': 'Desaceleración máxima',
  'braking.peakLateral': 'Agarre lateral máximo',
  'braking.trailScore': 'Puntuación de Trail-Braking',
  'braking.trailScoreDesc': 'Medida del aprovechamiento del círculo de fricción durante la transición de la frenada longitudinal al paso por curva lateral.',
  'braking.scoreOptimal': 'Óptimo',
  'braking.scoreGood': 'Bueno',
  'braking.scoreNeedsWork': 'Mejorable',
  'braking.sessionMedian': 'Mediana de sesión',
  'braking.selectedLap': 'Vuelta seleccionada',
  'braking.speedTransition': 'Transición de velocidad',
  'braking.decelAndGrip': 'Desaceleración y agarre',
  'braking.trailScoreAdviceOptimal': 'Excelente modulación del freno hacia la entrada de la curva. Alto aprovechamiento del círculo de fricción.',
  'braking.trailScoreAdviceGood': 'Transición suave. Oportunidad de mantener el trail-braking un poco más adentro en la entrada de la curva.',
  'braking.trailScoreAdviceNeedsWork': 'Suelta brusca del freno antes de girar. Concéntrate en soltar el freno progresivamente mientras giras.',
  'braking.overallHeader': 'Rendimiento general de frenada',
  'braking.overallHeaderDesc': 'Eficiencia de trail-braking en todo el circuito y consistencia en curvas en todas las vueltas y sesiones seleccionadas.',
  'braking.perCornerHeader': 'Análisis por curva',
  'braking.perCornerHeaderDesc': 'Cinemática detallada, círculo de fricción G-G y trazas de telemetría para la zona de frenada seleccionada.',
  'braking.overallScore': 'Puntuación global de Trail-Braking',
  'braking.overallScoreDesc': 'Aprovechamiento medio del círculo de fricción en todas las curvas y vueltas',
  'braking.mostConsistentCorner': 'Curva más consistente',
  'braking.leastConsistentCorner': 'Curva menos consistente',
  'braking.consistency': 'Consistencia',
  'braking.lapTimeline': 'Evolución vuelta a vuelta',
  'braking.sessionComparison': 'Comparación de sesiones',
  'braking.selectCornerHint': 'Haz clic para inspeccionar la curva',
  'braking.stdDevLabel': 'Desv. est.',
  'braking.ggDiagram': 'Diagrama G-G',
  'braking.frictionCircle': 'Círculo de fricción',
  'braking.telemetryChart': 'Telemetría de frenada',
  'braking.speed': 'Velocidad',
  'braking.gLong': 'G longitudinal',
  'braking.gLat': 'G lateral',
  'braking.gTotal': 'G combinada',
  'braking.allLaps': 'vueltas',
  'braking.compareLap': 'Comparar',
  'braking.comparisonLap': 'Comparación',
  'braking.clearComparison': 'Limpiar comparación',
  'braking.lapTime': 'Tiempo de vuelta',
  'braking.driver': 'Piloto',
  'braking.lap': 'Vuelta',
  'braking.lapSpeedTable': 'Desglose de vueltas de frenada',
  'braking.lapsAnalyzed': 'vueltas analizadas',
  'braking.legendDecel': 'Frenada recta',
  'braking.legendTrail': 'Trail-Braking',
  'braking.legendApex': 'Vértice',
  'braking.legendExit': 'Aceleración salida',

  // Corner Speed Analysis
  'analysis.corner.title': 'Análisis de velocidad en curva',
  'analysis.corner.desc': 'Mide y compara las velocidades de entrada, vértice y salida de curva entre vueltas y sesiones.',
  'corner.title': 'Análisis de velocidad en curva',
  'corner.wizardChooseTrack': 'Elegir circuito',
  'corner.wizardSelect': 'Seleccionar sesiones',
  'corner.wizardResults': 'Resultados',
  'corner.entrance': 'Entrada',
  'corner.apex': 'Vértice',
  'corner.exit': 'Salida',
  'corner.entranceSpeed': 'Velocidad de entrada',
  'corner.apexSpeed': 'Velocidad en el vértice',
  'corner.exitSpeed': 'Velocidad de salida',
  'corner.speedGain': 'Ganancia de velocidad',
  'corner.turn': 'Curva',
  'corner.leftTurn': 'Curva a la izquierda',
  'corner.rightTurn': 'Curva a la derecha',
  'corner.avgSpeed': 'Velocidad media',
  'corner.maxSpeed': 'Vel. máx.',
  'corner.minSpeed': 'Vel. mín.',
  'corner.fastest': 'Más rápida',
  'corner.slowest': 'Más lenta',
  'corner.spread': 'Dispersión',
  'corner.deltaToBest': 'Δ a la mejor',
  'corner.deltaToAvg': 'Δ a la media',
  'corner.allCornersOverview': 'Resumen de todas las curvas',
  'corner.aggregatedData': 'Estadísticas de velocidad agregadas',
  'corner.lapSpeedTable': 'Desglose de velocidad por vuelta',
  'corner.lapsAnalyzed': 'vueltas analizadas',
  'corner.noTracksWithCorners': 'No hay circuitos con trazado y curvas configuradas disponibles.',
  'corner.noSessionsForTrack': 'No se encontraron sesiones para el circuito',
  'corner.noCornersFound': 'No se encontraron anotaciones de curvas para este circuito.',
  'corner.selectCorner': 'Seleccionar curva',
  'corner.rank': 'Pos.',
  'corner.driver': 'Piloto',
  'corner.lap': 'Vuelta',
  'corner.lapTime': 'Tiempo de vuelta',
  'corner.session': 'Sesión',
  'corner.speed': 'Velocidad',
  'corner.avgMax': 'Med. / Máx.',
  'corner.activeMetric': 'Métrica activa:',
  'corner.metricSpeed': 'Velocidad',
  'corner.metricRpm': 'RPM',
  'corner.metricDuration': 'Duración',
  'corner.entranceRpm': 'RPM de entrada',
  'corner.apexRpm': 'RPM en el vértice',
  'corner.exitRpm': 'RPM de salida',
  'corner.rpmGain': 'Ganancia de RPM',
  'corner.rpm': 'RPM',
  'corner.duration': 'Duración',
  'corner.transitDuration': 'Duración de paso por curva',
  'corner.bestDuration': 'Mejor duración',
  'corner.avgDuration': 'Duración media',
  'corner.worstDuration': 'Duración más lenta',
  'corner.deltaToBestDuration': 'Δ a la mejor',
  'corner.fullTransit': 'Paso completo',



  // Sector analysis
  'sector.wizardChooseTrack': 'Elegir circuito',
  'sector.wizardDefine': 'Definir sectores',
  'sector.wizardSelect': 'Seleccionar sesiones',
  'sector.wizardResults': 'Resultados',
  'sector.title': 'Análisis de sectores',
  'sector.defineSectors': 'Definir sectores',
  'sector.clickToAdd': 'Haz clic para añadir · Arrastra para mover (máx. 3 sectores)',
  'sector.selectSessions': 'Seleccionar sesiones →',
  'sector.analyzingLap': '⏳ Analizando vuelta…',
  'sector.analyzeLap': '⚡ Analizar vuelta',
  'sector.noResults': 'No hay resultados disponibles',
  'sector.noResultsHint': 'Vuelve atrás y ajusta tus sectores o sesiones',
  'sector.trackSectors': 'Sectores del circuito',
  'sector.sectorN': 'Sector {n}',
  'sector.noSessionsForTrack': 'No se encontraron sesiones para el circuito',
  'sector.failedToLoad': 'Error al cargar el análisis de sectores',
  'sector.lapStats': 'Estadísticas de vueltas',
  'sector.lapStatsDriver': 'Piloto',
  'sector.lapStatsTotal': 'Total',

  // Sector panel
  'sectorPanel.time': 'Tiempo',
  'sectorPanel.topSpeed': 'Vel. punta',
  'sectorPanel.minSpeed': 'Vel. mín.',
  'sectorPanel.maxRpm': 'RPM máx.',
  'sectorPanel.minRpm': 'RPM mín.',
  'sectorPanel.duration': 'Duración',
  'sectorPanel.best': 'Mejor',
  'sectorPanel.avg': 'Media',
  'sectorPanel.median': 'Mediana',
  'sectorPanel.worst': 'Peor',
  'sectorPanel.p10': 'P10',
  'sectorPanel.p5': 'P5',
  'sectorPanel.consistency': 'Consistencia',
  'sectorPanel.lapByLap': 'Evolución vuelta a vuelta',
  'sectorPanel.sessionMedians': 'Medianas por sesión',
  'sectorPanel.medianTopSpeed': 'Mediana vel. punta',
  'sectorPanel.medianMinSpeed': 'Mediana vel. mín.',
  'sectorPanel.medianMaxRpm': 'Mediana RPM máx.',
  'sectorPanel.medianMinRpm': 'Mediana RPM mín.',
  'sectorPanel.medianTime': 'Mediana de tiempo',
  'sectorPanel.session': 'Sesión',
  'sectorPanel.lap': 'Vuelta',
  'sectorPanel.maxSpeed': 'Vel. máx.',

  // Split points
  'splitPoints.clearAll': 'Borrar todo',

  // Session selector
  'sessionSelector.allDrivers': 'Todos los pilotos',
  'sessionSelector.allWeather': 'Todo el clima',
  'sessionSelector.dryOnly': '☀️ Solo seco',
  'sessionSelector.wetOnly': '🌧️ Solo mojado',
  'sessionSelector.selectAll': 'Seleccionar todo',
  'sessionSelector.deselectAll': 'Deseleccionar todo',

  // Theoretical best
  'theoBest.title': 'Mejor vuelta teórica',
  'theoBest.type': 'Tipo',
  'theoBest.time': 'Tiempo',
  'theoBest.delta': 'Delta',
  'theoBest.theoretical': 'Teórica',
  'theoBest.actualBest': 'Mejor real',

  // Lap selector
  'lapSelector.title': 'Seleccionar vueltas',
  'lapSelector.loadingLaps': 'Cargando vueltas…',
  'lapSelector.noLaps': 'Sin vueltas',
  'lapSelector.best': 'MEJOR',

  // Navigation – races
  'nav.races': 'Carreras',

  // Tracks
  'tracks.title': 'Circuitos',
  'tracks.subtitle': 'Todos los circuitos y clasificaciones',
  'tracks.noData': 'No hay circuitos disponibles',
  'tracks.failedToLoad': 'Error al cargar los circuitos',
  'tracks.sessions': '{n} sesiones',
  'tracks.raceSessions': '{n} sesiones de carrera',
  'tracks.bestLap': 'Mejor vuelta',
  'tracks.rank': '#',
  'tracks.lapTime': 'Tiempo de vuelta',
  'tracks.driver': 'Piloto',
  'tracks.date': 'Fecha',
  'tracks.sectors': 'Sectores',
  'tracks.weather': 'Clima',
  'tracks.measuredLapsTab': 'Vueltas medidas',
  'tracks.raceTab': 'Carreras',
  'tracks.leaderboard': 'Clasificación',
  'tracks.category': 'Categoría',
  'tracks.season': 'Temporada',
  'tracks.position': 'Pos.',
  'tracks.sessionType': 'Tipo',
  'tracks.sourceCanonical': 'Circuito',
  'tracks.sourceSession': 'Solo sesión',
  'tracks.sourceRaceEvent': 'Solo carrera',
  'tracks.searchPlaceholder': 'Buscar circuitos…',
  'tracks.source': 'Origen',
  'tracks.searchHelp.title': 'Sintaxis de búsqueda de circuitos',
  'tracks.searchHelp.subtitle': 'Busca por nombre de circuito. No distingue entre mayúsculas, minúsculas ni acentos.',
  'tracks.searchHelp.nameField': '(texto)',
  'tracks.searchHelp.nameDesc': 'Coincide con los circuitos cuyo nombre contiene el texto indicado. Los caracteres acentuados coinciden independientemente de las tildes (p. ej., "Geneve" coincide con "Genève").',
  'tracks.searchHelp.example1': 'Wohlen',
  'tracks.searchHelp.example1Desc': 'Todos los circuitos que contienen "Wohlen"',
  'tracks.searchHelp.example2': 'franciacorta',
  'tracks.searchHelp.example2Desc': 'Coincidencia sin distinción de mayúsculas para "Franciacorta"',
  'tracks.searchHelp.example3': 'Sarno',
  'tracks.searchHelp.example3Desc': 'Todos los circuitos que contienen "Sarno"',

  // Track detail tabs
  'tracks.layoutTab': 'Trazado',
  'tracks.noTrackLayout': 'Trazado del circuito no disponible',
  'tracks.officialLapsTab': 'Vueltas oficiales',
  'tracks.noRaceEvents': 'No se encontraron eventos de carrera',
  'tracks.round': 'Ronda',
  'tracks.championship': 'Campeonato',
  'tracks.dateStart': 'Fecha',
  'tracks.country': 'País',
  'tracks.sessionsCount': 'Sesiones',
  'tracks.driversCount': 'Pilotos',
  // Track race events search
  'tracks.raceEvents.searchPlaceholder': 'Buscar eventos de carrera…',
  'tracks.raceEvents.searchHelp.title': 'Búsqueda de eventos de carrera',
  'tracks.raceEvents.searchHelp.subtitle': 'Filtra eventos de carrera por temporada o nombre de campeonato',
  'tracks.raceEvents.searchHelp.seasonField': 'season:<año>',
  'tracks.raceEvents.searchHelp.seasonDesc': 'Filtrar por año de temporada (coincidencia exacta)',
  'tracks.raceEvents.searchHelp.championshipField': 'championship:<nombre>',
  'tracks.raceEvents.searchHelp.championshipDesc': 'Filtrar por nombre de campeonato (sin distinguir mayúsculas)',
  'tracks.raceEvents.searchHelp.example1': 'season:2026',
  'tracks.raceEvents.searchHelp.example1Desc': 'Todos los eventos de la temporada 2026',
  'tracks.raceEvents.searchHelp.example2': 'championship:RMC',
  'tracks.raceEvents.searchHelp.example2Desc': 'Todos los eventos de campeonatos que contengan "RMC"',

  // Track leaderboard search
  'tracks.leaderboard.searchPlaceholder': 'Buscar vueltas...',
  'tracks.leaderboard.searchHelp.title': 'Búsqueda en la clasificación',
  'tracks.leaderboard.searchHelp.subtitle': 'Usa filtros para acotar los resultados',
  'tracks.leaderboard.searchHelp.driverField': 'driver:<nombre>',
  'tracks.leaderboard.searchHelp.driverDesc': 'Filtrar por nombre de piloto (sin distinguir mayúsculas)',
  'tracks.leaderboard.searchHelp.seasonField': 'season:<año>',
  'tracks.leaderboard.searchHelp.seasonDesc': 'Filtrar por año de temporada',
  'tracks.leaderboard.searchHelp.categoryField': 'category:<nombre>',
  'tracks.leaderboard.searchHelp.categoryDesc': 'Filtrar por categoría (p. ej. DD2, Junior)',
  'tracks.leaderboard.searchHelp.typeField': 'type:<tipoSesión>',
  'tracks.leaderboard.searchHelp.typeDesc': 'Filtrar por tipo de carrera (qualifying, heat-1, final...)',
  'tracks.leaderboard.searchHelp.posField': 'pos<:<N>',
  'tracks.leaderboard.searchHelp.posDesc': 'Posición final máxima (p. ej. pos<:3 = podio)',
  'tracks.leaderboard.searchHelp.tempMinField': 'temp>:<N>',
  'tracks.leaderboard.searchHelp.tempMinDesc': 'Temperatura mínima en °C',
  'tracks.leaderboard.searchHelp.tempMaxField': 'temp<:<N>',
  'tracks.leaderboard.searchHelp.tempMaxDesc': 'Temperatura máxima en °C',
  'tracks.leaderboard.searchHelp.fromField': 'from:<YYYY-MM-DD>',
  'tracks.leaderboard.searchHelp.fromDesc': 'Filtro de fecha de inicio',
  'tracks.leaderboard.searchHelp.toField': 'to:<YYYY-MM-DD>',
  'tracks.leaderboard.searchHelp.toDesc': 'Filtro de fecha de fin',
  'tracks.leaderboard.searchHelp.example1': 'driver:gubser season:2026',
  'tracks.leaderboard.searchHelp.example1Desc': 'Buscar un piloto en la temporada 2026',
  'tracks.leaderboard.searchHelp.example2': 'category:dd2 type:final',
  'tracks.leaderboard.searchHelp.example2Desc': 'Solo finales de DD2',
  'tracks.leaderboard.searchHelp.example3': 'pos<:3 from:2026-01-01',
  'tracks.leaderboard.searchHelp.example3Desc': 'Podios en 2026',

  // Drivers
  'drivers.title': 'Pilotos',
  'drivers.driver': 'Piloto',
  'drivers.events': 'Eventos',
  'drivers.noData': 'No se encontraron pilotos',
  'drivers.failedToLoad': 'Error al cargar los pilotos',
  'drivers.searchPlaceholder': 'Buscar por nombre…',

  // Races
  'races.title': 'Resultados de carreras',
  'races.seasons': 'Temporadas',
  'races.events': '{n} eventos',
  'races.categories': '{n} categorías',
  'races.round': 'Ronda {n}',
  'races.allCategories': 'Todas las categorías',
  'races.noEvents': 'No se encontraron eventos',
  'races.failedToLoad': 'Error al cargar los datos de carrera',
  'races.noData': 'No hay datos de carrera disponibles',
  'races.position': 'Pos',
  'races.kart': '#',
  'races.driver': 'Piloto',
  'races.bestLap': 'Mejor vuelta',
  'races.totalTime': 'Tiempo total',
  'races.gap': 'Dif.',
  'races.status': 'Estado',
  'races.grid': 'Parrilla',
  'races.lap': 'Vuelta',
  'races.laps': 'Vueltas',
  'races.penalty': 'Penalización',
  'races.lapProgression': 'Progresión por vuelta',
  'races.results': 'Resultados',
  'races.driverHistory': 'Historial del piloto',
  'races.raceStarts': 'Salidas',
  'races.podiums': 'Podios',
  'races.dnfDsq': 'DNF / DSQ',
  'races.qualiPoles': 'Poles en clasif.',
  'races.track': 'Circuito',
  'races.session': 'Sesión',
  'races.year': 'Año',
  'races.category': 'Categoría',
  'races.pole': 'Pole',
  'races.winner': 'Ganador',
  'races.finish': 'Llegada',
  'races.sessionType.qualifying': 'Clasificación',
  'races.sessionType.heat-1': 'Manga 1',
  'races.sessionType.heat-2': 'Manga 2',
  'races.sessionType.heat-3': 'Manga 3',
  'races.sessionType.heat-ab': 'Manga A-B',
  'races.sessionType.heat-bc': 'Manga B-C',
  'races.sessionType.heat-ac': 'Manga A-C',
  'races.sessionType.final': 'Final',

  // Race overview
  'races.overview': 'Resumen',

  // Driver race search
  'races.searchPlaceholder': 'Buscar carreras… p. ej. Castelletto o type:race',
  'races.querySyntaxHelp': 'Ayuda de sintaxis de búsqueda',
  'races.sessionCount': '{count} sesiones',
  'races.sessionCountSingular': '1 sesión',
  'races.eventsFound': '{n} evento(s) encontrado(s)',

  // Session detail tabs (below results table)
  'races.sessionTabWeather': 'Clima',
  'races.sessionTabPace': 'Ritmo',
  'common.comingSoon': 'Próximamente',

  // Driver pace
  'races.tabRaces': 'Carreras',
  'races.tabStats': 'Estadísticas',
  'races.tabPace': 'Ritmo',
  'races.paceDescription': 'Vuelta más rápida por fase',
  'races.paceNoData': 'No hay datos de ritmo disponibles para esta categoría.',
  'races.paceEvents': '{n} eventos',
  'races.paceQualifying': 'Mejor tiempo de vuelta en todos los eventos',

  // Driver stats
  'races.statWins': 'Victorias',
  'races.statAvgFinish': 'Posición media de llegada',
  'races.statSeasons': 'Temporadas',
  'races.statTracks': 'Circuitos',
  'races.statCategories': 'Categorías',
  'races.statTotalLaps': 'Vueltas totales',

  'driverSearchHelp.title': 'Sintaxis de búsqueda de carreras',
  'driverSearchHelp.subtitle': 'Filtra resultados de carrera usando pares campo:valor. Varios términos se combinan con AND.',
  'driverSearchHelp.bareText': '(texto libre)',
  'driverSearchHelp.bareTextDesc': 'Coincide con el nombre del circuito o del campeonato que contenga el texto.',
  'driverSearchHelp.track': 'track',
  'driverSearchHelp.trackDesc': 'Coincide con el nombre del circuito que contenga el valor.',
  'driverSearchHelp.championship': 'championship',
  'driverSearchHelp.championshipDesc': 'Coincide con el nombre del campeonato que contenga el valor.',
  'driverSearchHelp.category': 'category',
  'driverSearchHelp.categoryDesc': 'Coincide con el nombre de la categoría que contenga el valor.',
  'driverSearchHelp.type': 'type',
  'driverSearchHelp.typeDesc': 'Coincide con el tipo o etiqueta de sesión (p. ej. race, qualifying, heat).',
  'driverSearchHelp.position': 'position',
  'driverSearchHelp.positionDesc': 'Filtra por posición final. Admite =, >, >=, <, <= y rangos.',
  'driverSearchHelp.laps': 'laps',
  'driverSearchHelp.lapsDesc': 'Filtra por vueltas completadas. Admite operadores de comparación y rangos.',
  'driverSearchHelp.season': 'season',
  'driverSearchHelp.seasonDesc': 'Filtra por año de temporada del campeonato. Admite operadores de comparación.',
  'driverSearchHelp.from': 'from',
  'driverSearchHelp.fromDesc': 'Carreras en o después de una fecha. Acepta YYYY-MM-DD o relativas: -7d, -2w, -3m, -1y.',
  'driverSearchHelp.to': 'to',
  'driverSearchHelp.toDesc': 'Carreras en o antes de una fecha. Mismos formatos que "from".',
  'driverSearchHelp.operatorsTitle': 'Operadores y lógica',
  'driverSearchHelp.numericComparisons': 'Comparaciones numéricas:',
  'driverSearchHelp.range': 'Rango:',
  'driverSearchHelp.rangeDesc': '— coincide con valores entre 5 y 20 inclusive.',
  'driverSearchHelp.booleanLogic': 'Lógica booleana:',
  'driverSearchHelp.booleanLogicDesc': 'Los términos se unen implícitamente con',
  'driverSearchHelp.quotes': 'Comillas:',
  'driverSearchHelp.quotesDesc': 'Envuelve los valores con espacios entre comillas dobles, p. ej.',
  'driverSearchHelp.examplesTitle': 'Ejemplos de consultas',
  'driverSearchHelp.example1Desc': 'Resultados de carrera en Castelletto',
  'driverSearchHelp.example2Desc': 'Podios en el campeonato RMC del último año',
  'driverSearchHelp.example3Desc': 'Resultados en finales dentro del top 3',

  // Drivers List Search Help
  'driversListSearchHelp.title': 'Búsqueda de pilotos',
  'driversListSearchHelp.subtitle': 'Encuentra pilotos por nombre',
  'driversListSearchHelp.bareText': 'Palabras clave',
  'driversListSearchHelp.bareTextDesc': 'Las palabras clave se comparan con el nombre y el apellido. Varias palabras clave se tratan como condiciones AND.',
  'driversListSearchHelp.from': 'from',
  'driversListSearchHelp.fromDesc': 'Pilotos activos en o después de una fecha. Acepta YYYY-MM-DD o relativas: -7d, -2w, -3m, -1y.',
  'driversListSearchHelp.to': 'to',
  'driversListSearchHelp.toDesc': 'Pilotos activos en o antes de una fecha. Mismos formatos que "from".',
  'driversListSearchHelp.season': 'season',
  'driversListSearchHelp.seasonDesc': 'Pilotos activos en una temporada específica. Admite operadores de comparación como season:>2020.',
  'driversListSearchHelp.category': 'category',
  'driversListSearchHelp.categoryDesc': 'Pilotos activos en una categoría específica (p. ej. Rotax Max).',
  'driversListSearchHelp.example.yanick': 'Buscar pilotos llamados Yanick',
  'driversListSearchHelp.example.senn': 'Buscar pilotos llamados Senn',
  'driversListSearchHelp.example.from': 'Pilotos activos desde 2026',
  'driversListSearchHelp.example.season': 'Pilotos activos en 2025 o más reciente',
  'driversListSearchHelp.example.category': 'Pilotos activos en Rotax Max',
  'drivers.lastAppearance': 'Última participación',

  // Tyre Analysis
  'analysis.tyre.title': 'Análisis de neumáticos',
  'analysis.tyre.desc': 'Analiza el historial de neumáticos y predice tiempos por vuelta realistas según las condiciones actuales.',
  'tyre.selectTitle': 'Seleccionar neumático',
  'tyre.selectHint': 'Mostrando tus juegos de neumáticos usados más recientemente. También puedes escanear un código de barras.',
  'tyre.scanBarcode': 'Escanear',
  'tyre.barcodeSearch': 'Buscar por código de barras o nombre...',
  'tyre.fastestLaps': 'Vueltas más rápidas por circuito',
  'tyre.expectations': 'Expectativas realistas',
  'tyre.totalLaps': 'Vueltas totales recorridas',
  'tyre.totalSessions': 'Sesiones',
  'tyre.longestSession': 'Sesión más larga',
  'tyre.ageLaps': '{n} vueltas',
  'tyre.noData': 'Sin datos',
  'tyre.expectedMedian': 'Esperado',
  'tyre.matchingLaps': 'Vueltas coincidentes',
  'tyre.noTyresFound': 'No se encontraron juegos de neumáticos.',
  'tyre.noFastestLaps': 'Aún no hay vueltas registradas con este juego de neumáticos.',
  'tyre.noExpectations': 'No hay circuitos con datos GPS disponibles para predicciones.',
  'tyre.dry': 'Seco',
  'tyre.wet': 'Mojado',
  'tyre.pointCamera': 'Apunta tu cámara a un código de barras',
  'tyre.wizardSelect': 'Seleccionar neumático',
  'tyre.wizardResults': 'Resultados',
  'tyre.back': 'Atrás',
  'tyre.exit': 'Salir',
  'tyre.trackColumn': 'Circuito',
  'tyre.bestLapColumn': 'Mejor vuelta',
  'tyre.dateColumn': 'Fecha',
  'tyre.ageColumn': 'Uso',
  'tyre.weatherColumn': 'Clima',
  'tyre.tempColumn': 'Temp.',
  'tyre.expected': 'Esperado:',

  // Tyre Overview
  'analysis.tyreOverview.title': 'Resumen de neumáticos',
  'tyreOverview.summaryTotal': 'Total',
  'tyreOverview.summaryFresh': 'Nuevos',
  'tyreOverview.summaryWorn': 'Usados',
  'tyreOverview.summaryEndOfLife': 'Fin de vida útil',
  'tyreOverview.endOfLife': '⚠ Fin de vida útil',
  'tyreOverview.scanButton': 'Escanear',
  'tyreOverview.noTyres': 'No se encontraron neumáticos activos.',
  'tyreOverview.scanNotFound': 'No se encontró ningún neumático para el código de barras escaneado.',
  'tyreOverview.laps': 'vueltas',
  'tyreOverview.colTyre': 'Neumático',
  'tyreOverview.colCompound': 'Compuesto',
  'tyreOverview.colLaps': 'Vueltas',
  'tyreOverview.colLastUsed': 'Último uso',
  'tyreOverview.colStatus': 'Estado',
  'tyreOverview.discardButton': 'Marcar como descartado',
  'tyreOverview.discardAction': 'Descartar',
  'tyreOverview.discardSuccess': 'Juego de neumáticos marcado como descartado.',
  'tyreOverview.searchPlaceholder': 'Buscar neumáticos (p. ej. brand:Mojo compound:dry laps:<50)...',
  'tyreOverview.searchHelp.title': 'Búsqueda en resumen de neumáticos',
  'tyreOverview.searchHelp.subtitle': 'Filtra y encuentra juegos de neumáticos activos por marca, compuesto, vueltas, código de barras o circuito.',
  'tyreOverview.searchHelp.bareText': 'Texto',
  'tyreOverview.searchHelp.bareTextDesc': 'Coincide con marca, modelo, número de referencia, código de barras o último circuito utilizado.',
  'tyreOverview.searchHelp.brandDesc': 'Filtrar por fabricante o marca de neumáticos (p. ej. Mojo, Vega).',
  'tyreOverview.searchHelp.typeDesc': 'Filtrar por modelo o tipo de neumático (p. ej. D2, White).',
  'tyreOverview.searchHelp.nrDesc': 'Filtrar por número de referencia del juego de neumáticos.',
  'tyreOverview.searchHelp.compoundDesc': 'Filtrar por tipo de compuesto ("dry" o "wet").',
  'tyreOverview.searchHelp.lapsDesc': 'Filtrar por vueltas acumuladas con operadores de comparación (=, >, <, >=, <=) o rangos (p. ej. 0..20).',
  'tyreOverview.searchHelp.barcodeDesc': 'Filtrar por código de barras o ID de serie individual del neumático.',
  'tyreOverview.searchHelp.trackDesc': 'Filtrar por el nombre del circuito donde se usó por última vez el juego de neumáticos.',
  'tyreOverview.searchHelp.fromDesc': 'Coincide con neumáticos usados por última vez en o después de la fecha (YYYY-MM-DD o relativa como -30d).',
  'tyreOverview.searchHelp.toDesc': 'Coincide con neumáticos usados por última vez en o antes de la fecha (YYYY-MM-DD o relativa como -1m).',
  'tyreOverview.searchHelp.example.mojoDry': 'Neumáticos de compuesto seco de Mojo',
  'tyreOverview.searchHelp.example.lapsEol': 'Neumáticos que han alcanzado el fin de su vida útil (70+ vueltas)',
  'tyreOverview.searchHelp.example.lapsRange': 'Neumáticos nuevos o con poco uso de 0 a 20 vueltas',
  'tyreOverview.searchHelp.example.trackFrom': 'Neumáticos usados por última vez en Lonato desde el 1 de agosto de 2026',
  'tyreOverview.searchHelp.example.vegaWet': 'Neumáticos Vega o de compuesto de lluvia',

  // Devices
  'device.alfano7': 'Alfano 7',
  'device.mychron5': 'MyChron 5',

  // Import
  'import.title': 'Importar sesiones',
  'import.uploadZip': 'Subir archivos de telemetría',
  'import.uploadZipDesc': 'Sube archivos de datos de telemetría de Alfano 7 (ZIP) o MyChron 5 (.xrk, .xrz, ZIP) desde tu ordenador',
  'import.dragDropZip': 'Arrastra y suelta archivos ZIP, XRK o XRZ aquí',
  'import.dropZipHere': 'Suelta los archivos aquí',
  'import.orBrowse': 'o',
  'import.browseFiles': 'explorar archivos',
  'import.filesSelected': '{n} archivo(s) seleccionado(s)',
  'import.upload': 'Subir',
  'import.uploading': 'Subiendo…',
  'import.uploadingPct': 'Subiendo… {n}%',
  'import.imported': 'Importadas',
  'import.skipped': 'Omitidas',
  'import.errors': 'Errores',
  'import.errorDetailsTitle': 'Detalles del error',
  'import.successMessage': 'Sesiones importadas correctamente. Aparecerán en tu panel.',
  'import.noNewSessions': 'No se encontraron sesiones nuevas. Todos los archivos ya habían sido importados.',
  'import.onlyZipAccepted': 'Solo se aceptan archivos ZIP, XRK y XRZ',
  'import.onlySupportedAccepted': 'Solo se aceptan archivos ZIP, XRK y XRZ',
  'import.uploadFailed': 'Error en la subida (HTTP {status})',
  'import.connectionLost': 'Conexión perdida',
  'import.uploadAborted': 'Subida cancelada',
  'import.importFailed': 'Error al importar',
  'import.importedFromZip': '{n} sesión(es) importada(s)',
  'import.zipImportFailed': 'Error al importar: {error}',
  'import.useCurrentSetup': 'Usar setup actual',
  'offline.title': 'Sin conexión',
  'offline.message': 'Actualmente no estás conectado a internet. Comprueba tu conexión de red e inténtalo de nuevo.',
  'settings.uploadSessions': 'Subir sesiones',
  'settings.uploadSessionsDesc': 'Sube archivos de telemetría de Alfano 7 o MyChron 5 para importar los datos de tus sesiones.',
  // Sharing
  'sharing.title': 'Compartir',
  'sharing.searchPlaceholder': 'Buscar usuarios por nombre o correo...',
  'sharing.noUsersFound': 'No se encontraron usuarios',
  'sharing.shareAll': 'Compartir todas las sesiones',
  'sharing.shareSelected': 'Compartir solo las seleccionadas',
  'sharing.readOnly': 'Solo lectura',
  'sharing.readWrite': 'Lectura y escritura',
  'sharing.share': 'Compartir',
  'sharing.myShares': 'Mis recursos compartidos (salientes)',
  'sharing.sharedWithMe': 'Compartidos conmigo (entrantes)',
  'sharing.revoke': 'Revocar',
  'sharing.leave': 'Salir',
  'sharing.permissions': 'Permisos',
  'sharing.sharedAll': 'Todas las sesiones',
  'sharing.sharedSelected': 'Sesiones seleccionadas',
  'sharing.searching': 'Buscando…',
  'sharing.owner': 'Propietario: {name}',
  'sharing.selectSessions': 'Seleccionar sesiones',
  'sharing.noSessions': 'No hay sesiones disponibles',
  'sharing.laps': 'vueltas',
  'sharing.searchHint': 'Escribe al menos 2 caracteres para buscar',
  'sharing.newShare': 'Nuevo recurso compartido',
  'sharing.stepUsers': 'Paso 1: Seleccionar usuarios',
  'sharing.stepConfigure': 'Paso 2: Configurar uso compartido',
  'sharing.stepPermissions': 'Paso 3: Permisos',
  'sharing.next': 'Siguiente',
  'sharing.selectedUsers': 'Usuarios seleccionados',
  'sharing.selectedSessions': '{count} sesión(es) seleccionada(s)',
  'sharing.filterSessions': 'Filtrar sesiones...',
  'sharing.showSelected': 'Mostrar seleccionadas',
  'sharing.noSharesYet': 'Aún no hay sesiones compartidas',
  'sharing.emptyDescription': 'Comparte tus sesiones con otros pilotos o mecánicos.',
  'sharing.stepScope': 'Paso 1: Seleccionar sesiones',
  'sharing.stepConfirm': 'Paso 2: Confirmar',
  'sharing.shareWithTeam': 'Compartir con este equipo',

  // Session tabs

  // Setup (readonly view)
  'setup.noSetup': 'No hay datos de setup disponibles para esta sesión.',
  'setup.loadingSetup': 'Cargando setup…',
  'setup.loadFailed': 'Error al cargar los datos de setup.',
  'common.none': 'Ninguno',
  'common.notSet': 'No definido',
  'nav.setupSections': 'Secciones de setup',
  // Pressure
  'pressure.tyre': 'Juego de neumáticos',
  'pressure.outgoing': 'Salida',
  'pressure.cold': 'frío',
  'pressure.incoming': 'Entrada',
  'pressure.hot': 'caliente',
  'pressure.fl': 'DI',
  'pressure.fr': 'DD',
  'pressure.rl': 'TI',
  'pressure.rr': 'TD',
  // Front
  'front.caster': 'Avance (Caster)',
  'front.camber': 'Caída (Camber)',
  'front.trackWidth': 'Ancho de vía delantero',
  'front.trackWidthUnit': 'mm',
  'front.rideHeight': 'Altura delantera',
  'front.frontHubs': 'Bujes delanteros',
  'front.ackermann': 'Ackermann',
  'front.inner': 'Interior',
  'front.outer': 'Exterior',
  'front.toeAlignment': 'Convergencia (Toe)',
  'front.torsionBar': 'Barra de torsión',
  'front.hard': 'Dura',
  'front.medium': 'Media',
  'front.soft': 'Blanda',
  // Rear
  'rear.axle': 'Eje trasero',
  'rear.rearWidth': 'Ancho trasero',
  'rear.rearHubs': 'Bujes traseros',
  'rear.loosenedBumper': 'Parachoques trasero suelto',
  // Engine
  'engine.engine': 'Motor',
  'engine.sparkPlug': 'Bujía',
  'engine.gearRatio': 'Relación de transmisión',
  'engine.pinion': 'Piñón',
  'engine.crown': 'Corona',
  // Carburetor
  'carb.carburetor': 'Carburador',
  'carb.mainJet': 'Chiclé de alta',
  'carb.idleJet': 'Chiclé de baja',
  'carb.needleClip': 'Clip de aguja',
  'carb.airScrew': 'Tornillo de aire',
  'carb.floatHeight': 'Altura de flotador',
  // Chassis
  'chassisSelect.chassis': 'Chasis',
  'chassisSelect.weight': 'Peso',
  // Notes
  'notes.notes': 'Notas',
  'notes.placeholder': 'Notas de setup…',

  // Navigation – inventory
  'nav.inventory': 'Inventario',
  'nav.organization': 'Organización',
  'nav.setup': 'Setup',

  // Materials — common
  'common.add': 'Añadir',
  'common.save': 'Guardar',
  'common.create': 'Crear',
  'common.created': 'Creado',
  'common.edit': 'Editar',
  'common.delete': 'Eliminar',
  'common.optional': '(opcional)',
  'common.brand': 'Marca',
  'common.type': 'Tipo',
  'materials.profile': 'Perfil',
  'materials.selectProfile': 'Seleccionar perfil…',
  'common.nr': 'N.º',
  'common.nrInfo': 'Número secuencial para identificar este elemento.',
  'common.team': 'Equipo',
  'common.year': 'Año',
  'common.stiffness': 'Dureza',
  'common.width': 'Anchura',
  'common.position': 'Posición',

  // Materials — CRUD
  'crud.requiredField': '{field} es obligatorio',
  'crud.updated': '{entity} actualizado',
  'crud.created': '{entity} creado',
  'crud.deleted': '{entity} eliminado',
  'crud.confirmDelete': '¿Eliminar {entity} "{name}"?\nEsta acción no se puede deshacer.',
  'crud.emptyState': 'Aún no hay {title}. Añade tu primer {entity} arriba.',
  'crud.editEntity': 'Editar {entity}',
  'crud.newEntity': 'Nuevo {entity}',

  // Materials — general
  'materials.readOnly': 'Solo lectura',
  'materials.selectTeam': 'Selecciona un equipo para ver el inventario.',

  // Materials — tabs
  'materials.tab.engines': 'Motores',
  'materials.tab.tyres': 'Neumáticos',
  'materials.tab.chassis': 'Chasis',
  'materials.tab.carburetors': 'Carburadores',
  'materials.tab.axles': 'Ejes',
  'materials.tab.hubs': 'Bujes',
  'materials.tab.spark_plugs': 'Bujías',

  // Materials — entities
  'materials.entity.engine': 'Motor',
  'materials.entity.tyre': 'Neumático',
  'materials.entity.chassis': 'Chasis',
  'materials.entity.carburetor': 'Carburador',
  'materials.entity.axle': 'Eje',
  'materials.entity.hub': 'Buje',
  'materials.entity.spark_plug': 'Bujía',

  // Materials — tyre-specific
  'materials.tyre.compound': 'Compuesto',
  'materials.tyre.compound.dry': 'Seco',
  'materials.tyre.compound.wet': 'Mojado',
  'materials.tyre.discarded': 'Descartado',

  // Materials — tyre IDs
  'materials.tyreId.title': 'IDs de neumáticos',
  'materials.tyreId.fl': 'DI',
  'materials.tyreId.fr': 'DD',
  'materials.tyreId.rl': 'TI',
  'materials.tyreId.rr': 'TD',
  'materials.tyreId.scan': 'Escanear código de barras',
  'materials.tyreId.duplicateInSet': 'ID de neumático duplicado en este juego',
  'materials.tyreId.duplicateInOtherSet': 'El ID {id} ya está en uso en {tyre}',
  'materials.tyreId.placeholder': 'Escanear o introducir ID de neumático',
  'materials.tyreId.crossSetInfo': 'Algunos IDs de neumáticos entran en conflicto con otros juegos. Pulsa Guardar de nuevo para sobrescribir.',

  // Materials — hub positions
  'materials.position.front': 'Delantero',
  'materials.position.rear': 'Trasero',
  // Setup editing
  'setup.edit': 'Editar setup',
  'setup.editTitle': 'Editar setup',
  'setup.save': 'Guardar setup',
  'setup.saving': 'Guardando…',
  'setup.saved': 'Setup guardado',
  'setup.saveFailed': 'Error al guardar el setup',
  'setup.pageTitle': 'Setup actual',
  'setup.pageSubtitle': 'Configuración base para las nuevas sesiones importadas',
  'setup.editCurrentTitle': 'Editar setup actual',
  'setup.noCurrentSetup': 'Aún no hay ningún setup configurado. Haz clic en "Editar setup" para empezar.',
  // Propagation
  'propagation.title': 'Aplicar cambios',
  'propagation.subtitle': 'Aplicar los cambios de setup a otras sesiones',
  'propagation.changes': 'Cambios',
  'propagation.sessions': 'Sesiones',
  'propagation.selectAll': 'Seleccionar todo',
  'propagation.deselectAll': 'Deseleccionar todo',
  'propagation.apply': 'Aplicar',
  'propagation.applying': 'Aplicando…',
  'propagation.applied': 'Aplicado a las sesiones',
  'propagation.skip': 'Omitir',
  'propagation.selectAtLeastOne': 'Selecciona al menos una sesión',
  'propagation.noMatching': 'No se encontraron sesiones coincidentes',
  // Propagation field labels
  'propagation.field.chassis': 'Chasis',
  'propagation.field.weight': 'Peso',
  'propagation.field.engine': 'Motor',
  'propagation.field.tyre': 'Neumático',
  'propagation.field.carburetor': 'Carburador',
  'propagation.field.axle': 'Eje trasero',
  'propagation.field.flOut': 'DI Salida',
  'propagation.field.frOut': 'DD Salida',
  'propagation.field.rlOut': 'TI Salida',
  'propagation.field.rrOut': 'TD Salida',
  'propagation.field.flIn': 'DI Entrada',
  'propagation.field.frIn': 'DD Entrada',
  'propagation.field.rlIn': 'TI Entrada',
  'propagation.field.rrIn': 'TD Entrada',
  'propagation.field.rearWidth': 'Ancho trasero',
  'propagation.field.frontHubs': 'Bujes delanteros',
  'propagation.field.rearHubs': 'Bujes traseros',
  'propagation.field.rearBumper': 'Parachoques trasero',
  'propagation.field.caster': 'Avance (Caster)',
  'propagation.field.camber': 'Caída (Camber)',
  'propagation.field.trackWidth': 'Ancho de vía delantero',
  'propagation.field.rideHeight': 'Altura delantera',
  'propagation.field.ackermann': 'Ackermann',
  'propagation.field.toe': 'Convergencia (Toe)',
  'propagation.field.torsionBar': 'Barra de torsión',
  'propagation.field.frontSprocket': 'Piñón',
  'propagation.field.rearSprocket': 'Corona',
  'propagation.field.mainJet': 'Chiclé de alta',
  'propagation.field.idleJet': 'Chiclé de baja',
  'propagation.field.needleClip': 'Clip de aguja',
  'propagation.field.airScrew': 'Tornillo de aire',
  'propagation.field.floatHeight': 'Altura de flotador',
  'propagation.field.notes': 'Notas',
  'propagation.field.sparkPlug': 'Bujía',
  // Common additions
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.skip': 'Omitir',
  'common.applying': 'Aplicando…',

  // Teams
  'nav.teams': 'Equipos',
  'team.subtitle': 'Gestiona tus equipos y miembros',
  'team.create': 'Crear equipo',
  'team.name': 'Nombre del equipo',
  'team.members': 'Miembros',
  'team.role.read': 'Lectura',
  'team.role.write': 'Escritura',
  'team.role.manage': 'Gestión',
  'team.role.owner': 'Propietario',
  'team.addMember': 'Añadir miembro',
  'team.removeMember': 'Eliminar miembro',
  'team.leave': 'Abandonar equipo',
  'team.confirmLeave': '¿Seguro que quieres abandonar este equipo?',
  'team.cannotLeaveOwner': 'No puedes abandonar el equipo porque eres el propietario.',
  'team.created': 'Equipo creado',
  'team.memberAdded': 'Miembro añadido',
  'team.memberRemoved': 'Miembro eliminado',
  'team.roleUpdated': 'Rol actualizado',
  'team.renamed': 'Equipo renombrado',
  'team.empty': 'No se encontraron equipos. Crea uno para empezar.',
  'team.noWriteAccess': 'No tienes permisos de escritura en este equipo.',
  'team.tab.members': 'Miembros',
  'team.tab.sharing': 'Compartir',
  'team.members.searchPlaceholder': 'Buscar miembros...',
  'team.sharing.searchPlaceholder': 'Buscar recursos compartidos...',
  'team.members.searchTitle': 'Buscar miembros',
  'team.members.searchSubtitle': 'Filtra miembros por nombre, correo o rol',
  'team.sharing.searchTitle': 'Buscar recursos compartidos',
  'team.sharing.searchSubtitle': 'Filtra recursos compartidos por propietario o tipo',
  'team.members.field.bareText': '(cualquier texto)',
  'team.members.field.bareTextDesc': 'Busca por nombre',
  'team.members.field.name': 'name:',
  'team.members.field.nameDesc': 'Filtrar por nombre del miembro',
  'team.members.field.role': 'role:',
  'team.members.field.roleDesc': 'Filtrar por rol (read, write, manage)',
  'team.sharing.field.bareText': '(cualquier texto)',
  'team.sharing.field.bareTextDesc': 'Busca por nombre del propietario',
  'team.sharing.field.owner': 'owner:',
  'team.sharing.field.ownerDesc': 'Filtrar por propietario del recurso compartido',
  'team.sharing.field.type': 'type:',
  'team.sharing.field.typeDesc': 'Filtrar por tipo (all, selected)',

  // Lap Diff Analysis
  'analysis.lapdiff.title': 'Diferencia de vueltas',
  'analysis.lapdiff.desc': 'Superpón dos vueltas y resalta las diferencias de velocidad, RPM y aceleración.',
  'lapdiff.selectHint': 'Selecciona exactamente 2 vueltas para comparar.',
  'lapdiff.compare': 'Comparar',
  'lapdiff.comparing': 'Comparando…',
  'lapdiff.viewLapA': 'Ver vuelta A',
  'lapdiff.viewLapB': 'Ver vuelta B',
  'lapdiff.tabTime': 'Tiempo',
  'lapdiff.tabSpeed': 'Velocidad',
  'lapdiff.tabRpm': 'RPM',
  'lapdiff.tabAcceleration': 'Aceleración',
  'lapdiff.timeChartTitle': 'Tiempo perdido según la posición en pista',
  'lapdiff.timeGained': 'Tiempo ganado',
  'lapdiff.timeLost': 'Tiempo perdido',
  'lapdiff.cumulativeDelta': 'Δt acumulado',
  'lapdiff.segmentDelta': 'Δt de segmento',
  'lapdiff.trackPosition': 'Posición en pista',
  'lapdiff.avgDiff': 'Dif. media',
  'lapdiff.maxDiff': 'Dif. máx.',
  'lapdiff.noGpsData': 'No hay datos GPS disponibles para la comparación.',
  'lapdiff.pctBetter': '% mejor',
  'lapdiff.segmentTime': 'Segmento',
  'lapdiff.fullLap': 'Vuelta completa',
  'lapdiff.fasterBy': '{lap} más rápida por {time}',
  'lapdiff.equalTime': 'Mismo tiempo',
  'lapdiff.clearAnchors': 'Borrar anclajes',
  'lapdiff.clickToPlace': 'Haz clic en la pista para colocar anclajes',
  'lapdiff.segmentRange': 'Segmentos #{start} – #{end}',
  'lapdiff.segmentDetail': 'Segmento #{index}',

  // Aggregation Analysis
  'analysis.aggregation.title': 'Agregación',
  'analysis.aggregation.desc': 'Agrega puntos de frenada, aceleración y cambio de marcha entre sesiones en el mapa del circuito.',
  'aggregation.brakingPoints': 'Frenada',
  'aggregation.accelerationPoints': 'Aceleración',
  'aggregation.upshiftPoints': 'Subida de marcha',
  'aggregation.top10Title': 'Top 10 vueltas más rápidas',
  'aggregation.noData': 'No se detectaron puntos de datos',
  'aggregation.noDataHint': 'Prueba a seleccionar otras sesiones.',
  'aggregation.trackShapeRequired': 'Se requiere trazado del circuito',
  'aggregation.trackShapeRequiredHint': 'Se requiere un trazado oficial del circuito para mostrar los diagramas de caja de agregación. Crea un trazado del circuito en el editor.',
  'aggregation.sessionSelectionHint': 'Cuantas más sesiones se incluyan, mayor será la calidad y precisión de las zonas agregadas.',
  'aggregation.brakingSegment': 'Zona de frenada',
  'aggregation.accelerationSegment': 'Zona de aceleración',
  'aggregation.upshiftSegment': 'Zona de cambio de marcha',
  'aggregation.tooltipSamples': ({ count }) => `${count} muestras`,
  'aggregation.tooltipMedian': 'Mediana',
  'aggregation.tooltipSpread': 'Dispersión',
  'aggregation.gpsHeatmap': 'Mapa de calor GPS',
  'aggregation.eventZones': 'Zonas de eventos',
  'aggregation.heatmapLow': 'Baja',
  'aggregation.heatmapHigh': 'Alta',
  'aggregation.selectedLapLine': 'Vuelta seleccionada',
  'aggregation.lapsIncluded': '{count} vueltas',
  'gearshifting.wizardChooseTrack': 'Elegir circuito',
  'gearshifting.wizardSelect': 'Seleccionar sesiones',
  'gearshifting.wizardResults': 'Resultados',
  'gearshifting.analyzingLap': 'Analizando…',

  // Aggregation Diff Analysis
  'analysis.aggregationdiff.title': 'Diferencia de agregación',
  'analysis.aggregationdiff.desc': 'Compara dos agregaciones de sesiones para resaltar diferencias en trazada, frenada, aceleración y cambios de marcha.',
  'aggregationdiff.groupA': 'Grupo A',
  'aggregationdiff.groupB': 'Grupo B',
  'aggregationdiff.baseline': 'Referencia',
  'aggregationdiff.comparison': 'Comparación',
  'aggregationdiff.groupLabelPlaceholder': 'Etiqueta personalizada (p. ej. Mañana en seco)',
  'aggregationdiff.loadSavedAggregation': 'Cargar desde una agregación guardada…',
  'aggregationdiff.selectHint': 'Selecciona sesiones para el Grupo A (Referencia) y el Grupo B (Comparación) para resaltar diferencias en trazada, frenada, aceleración y cambios de marcha.',
  'aggregationdiff.selectHintA': 'Configura el Grupo A (Referencia) seleccionando una sola vuelta o una o más sesiones.',
  'aggregationdiff.selectHintB': 'Configura el Grupo B (Comparación) seleccionando una sola vuelta o una o más sesiones para comparar con el Grupo A.',
  'aggregationdiff.compare': 'Comparar agregaciones',
  'aggregationdiff.bestLap': 'Mejor vuelta',
  'aggregationdiff.medianLap': 'Vuelta mediana',
  'aggregationdiff.consistency': 'Consistencia (σ)',
  'aggregationdiff.lapsAndSessions': '{laps} vueltas · {sessions} sesiones',
  'aggregationdiff.layerDiffHeatmap': 'Mapa de calor de dif. de trazada',
  'aggregationdiff.layerMedianLines': 'Trazadas medianas',
  'aggregationdiff.layerEventDiffs': 'Dif. de zonas de eventos',
  'aggregationdiff.hideUnchanged': 'Atenuar < 1,5 m',
  'aggregationdiff.keyDifferencesTitle': 'Diferencias clave',
  'aggregationdiff.keyDifferencesSubtitle': 'Tramos de pista ordenados por diferencia de tiempo con posibles causas. Haz clic en un tramo para enfocarlo en el mapa.',
  'aggregationdiff.filterAll': 'Todo',
  'aggregationdiff.filterLine': 'Trazada',
  'aggregationdiff.filterBraking': 'Frenada',
  'aggregationdiff.filterAcceleration': 'Aceleración',
  'aggregationdiff.filterUpshift': 'Subida de marcha',
  'aggregationdiff.filterTopSpeed': 'Vel. punta',
  'aggregationdiff.possibleReasons': 'Posibles causas',
  'aggregationdiff.topSpeedPeak': 'Pico {a} vs {b} km/h',
  'aggregationdiff.laterBy': '{group} {dist} m más tarde',
  'aggregationdiff.earlierBy': '{group} {dist} m antes',
  'aggregationdiff.widerBy': 'Dispersión +{dist} m más amplia',
  'aggregationdiff.tighterBy': 'Dispersión {dist} m más estrecha',
  'aggregationdiff.onlyInGroup': 'Solo en {group}',
  'aggregationdiff.lineSeparation': '{dist} m máx. separación de trazada (zona de {len} m)',
  'aggregationdiff.lineOffsetLeft': 'Izquierda +{dist} m',
  'aggregationdiff.lineOffsetRight': 'Derecha +{dist} m',
  'aggregationdiff.noSignificantDiffs': 'No se encontraron diferencias significativas para este filtro.',
  'aggregationdiff.sharedLine': 'Trazada compartida',
  'aggregationdiff.clearFocus': 'Limpiar selección',
  'aggregationdiff.avgSpeed': 'Vel. media',
  'aggregationdiff.speedDiff': 'Dif. de velocidad',
  'aggregationdiff.lineOffset': 'Desplazamiento de trazada',
  'aggregationdiff.layerFasterSegments': 'Segmentos más rápidos',
  'aggregationdiff.fasterSegmentLegend': 'Segmento más rápido (Velocidad)',
  'aggregationdiff.estTimeGained': '{group} más rápido por {time}',
  'aggregationdiff.estTimeLost': '{group} más rápido por {time}',
  'aggregationdiff.estTimeNeutral': 'Est. ±0,00 s',

  // Analysis History
  'analysis.history.title': 'Historial de análisis',
  'analysis.history.subtitle': 'Vuelve a abrir y gestiona análisis de telemetría evaluados anteriormente',
  'analysis.history.filterAll': 'Todas las herramientas',
  'analysis.history.filterSector': 'Sectores',
  'analysis.history.filterCorner': 'Curvas',
  'analysis.history.filterBraking': 'Frenada',
  'analysis.history.filterLapDiff': 'Dif. de vueltas',
  'analysis.history.filterAggregation': 'Agregación',
  'analysis.history.filterAggregationDiff': 'Dif. de agregación',
  'analysis.history.groupsScope': '{a} vs {b} sesión(es)',
  'analysis.history.empty': 'No se encontraron análisis guardados',
  'analysis.history.emptyDesc': 'Los análisis que ejecutes con la sesión iniciada aparecerán automáticamente aquí.',
  'analysis.history.open': 'Abrir',
  'analysis.history.rename': 'Renombrar',
  'analysis.history.delete': 'Eliminar',
  'analysis.history.deleteConfirm': '¿Seguro que quieres eliminar este análisis del historial?',
  'analysis.history.deleteSuccess': 'Análisis eliminado',
  'analysis.history.renameSuccess': 'Análisis renombrado',
  'analysis.history.searchPlaceholder': 'Buscar en el historial de análisis...',
  'analysis.history.loading': 'Cargando análisis...',
  'analysis.history.table.type': 'Tipo',
  'analysis.history.table.name': 'Nombre',
  'analysis.history.table.track': 'Circuito',
  'analysis.history.table.scope': 'Alcance',
  'analysis.history.table.created': 'Creado',
  'analysis.history.table.actions': 'Acciones',
  'analysis.history.total': '{n} en total',
  'analysis.history.sessionsCount': '{n} sesión(es)',
  'analysis.history.lapsCount': '{n} vuelta(s)',
  'analysis.history.viewAll': 'Ver historial completo',
  'analysis.sessionRemoved.title': 'Sesión eliminada',
  'analysis.sessionRemoved.description': 'La sesión de telemetría utilizada por este análisis ha sido eliminada y este análisis ya no se puede abrir.',
  'analysis.sessionRemoved.deleteAnalysis': 'Eliminar análisis',
  'analysis.sessionRemoved.close': 'Cerrar',

  /* ── Footer ──── */
  'footer.contact': 'Contacto',
  'footer.privacyPolicy': 'Política de privacidad',
  'footer.reportBug': 'Informar de un error',
  'footer.bugReportTitle': 'Informar de un error',
  'footer.description': 'Descripción',
  'footer.descriptionPlaceholder': 'Describe el problema que has encontrado...',
  'footer.submit': 'Enviar',
  'footer.submitting': 'Enviando...',
  'footer.submitted': 'Informe de error enviado. ¡Gracias!',
  'footer.submitFailed': 'Error al enviar el informe.',

  /* ── Error auto-reporting & Error Boundary ─────────────────────────── */
  'error.autoReported': 'Se ha producido un error y se ha notificado automáticamente.',
  'errorBoundary.title': 'Algo salió mal',
  'errorBoundary.message': 'Se ha producido un error inesperado y se ha notificado al servidor.',
  'errorBoundary.reload': 'Recargar página',
  'errorBoundary.reset': 'Intentar de nuevo',
  'errorBoundary.showDetails': 'Mostrar detalles del error',
  'errorBoundary.hideDetails': 'Ocultar detalles del error',

  /* ── Setup Coach ──────────────────────────────────────────── */
  'coach.title': 'Asesor de Setup',
  'coach.subtitle': 'Base de conocimientos de ajustes de setup de karting organizada por objetivo de conducción. Selecciona un problema para ver los cambios recomendados y sus efectos.',
  'coach.disclaimer': 'Estas recomendaciones son pautas generales para karts Rotax Max. Prueba siempre los cambios de forma incremental y ajústalos según las condiciones de la pista, las sensaciones del piloto y el estado de los neumáticos.',
  'coach.col.parameter': 'Parámetro',
  'coach.col.change': 'Cambio',
  'coach.col.effect': 'Efecto',
  'coach.col.sideEffects': 'Efectos secundarios',
  'coach.col.effectiveness': 'Efectividad',

  // Reduce Understeer
  'coach.goal.understeer.title': 'Reducir el subviraje',
  'coach.goal.understeer.desc': 'El kart se abre en las curvas y no sigue la trazada deseada. Los neumáticos delanteros pierden agarre antes que los traseros, haciendo que el kart no responda bien al giro del volante.',
  'coach.goal.understeer.adj1.param': 'Ancho de vía delantero',
  'coach.goal.understeer.adj1.change': 'Ensanchar',
  'coach.goal.understeer.adj1.effect': 'Más agarre mecánico delantero',
  'coach.goal.understeer.adj1.side': 'Puede aumentar la agresividad del tren delantero',
  'coach.goal.understeer.adj2.param': 'Avance delantero (Caster)',
  'coach.goal.understeer.adj2.change': 'Aumentar',
  'coach.goal.understeer.adj2.effect': 'Más agarre delantero al entrar en curva',
  'coach.goal.understeer.adj2.side': 'Menor estabilidad en recta',
  'coach.goal.understeer.adj3.param': 'Caída delantera (Camber)',
  'coach.goal.understeer.adj3.change': 'Añadir (más negativa)',
  'coach.goal.understeer.adj3.effect': 'Más agarre delantero a mitad de curva',
  'coach.goal.understeer.adj3.side': 'Desgaste irregular de neumáticos',
  'coach.goal.understeer.adj4.param': 'Altura delantera',
  'coach.goal.understeer.adj4.change': 'Bajar',
  'coach.goal.understeer.adj4.effect': 'Centro de gravedad más bajo, más agarre',
  'coach.goal.understeer.adj4.side': 'Riesgo de tocar fondo con el chasis',
  'coach.goal.understeer.adj5.param': 'Eje trasero',
  'coach.goal.understeer.adj5.change': 'Más blando (menos rígido)',
  'coach.goal.understeer.adj5.effect': 'Libera la parte trasera para rotar mejor',
  'coach.goal.understeer.adj5.side': 'Puede causar inestabilidad trasera',
  'coach.goal.understeer.adj6.param': 'Presión de neumáticos delanteros',
  'coach.goal.understeer.adj6.change': 'Aumentar ligeramente',
  'coach.goal.understeer.adj6.effect': 'Respuesta delantera más directa',
  'coach.goal.understeer.adj6.side': 'Menor huella de contacto',

  // Reduce Oversteer
  'coach.goal.oversteer.title': 'Reducir el sobreviraje',
  'coach.goal.oversteer.desc': 'La parte trasera del kart desliza en las curvas, haciendo que el kart rote de forma demasiado agresiva. Los neumáticos traseros pierden agarre antes que los delanteros, provocando sobreviraje brusco o una trasera suelta.',
  'coach.goal.oversteer.adj1.param': 'Ancho de vía delantero',
  'coach.goal.oversteer.adj1.change': 'Estrechar',
  'coach.goal.oversteer.adj1.effect': 'Menos agarre delantero, equilibra el comportamiento',
  'coach.goal.oversteer.adj1.side': 'Menor respuesta de dirección',
  'coach.goal.oversteer.adj2.param': 'Avance delantero (Caster)',
  'coach.goal.oversteer.adj2.change': 'Reducir',
  'coach.goal.oversteer.adj2.effect': 'Menos agarre delantero',
  'coach.goal.oversteer.adj2.side': 'Entrada en curva más lenta',
  'coach.goal.oversteer.adj3.param': 'Eje trasero',
  'coach.goal.oversteer.adj3.change': 'Endurecer (más rígido)',
  'coach.goal.oversteer.adj3.effect': 'Más agarre trasero',
  'coach.goal.oversteer.adj3.side': 'El chasis puede rebotar en los baches',
  'coach.goal.oversteer.adj4.param': 'Ancho trasero',
  'coach.goal.oversteer.adj4.change': 'Ensanchar',
  'coach.goal.oversteer.adj4.effect': 'Más agarre mecánico trasero',
  'coach.goal.oversteer.adj4.side': 'Menor rotación trasera',
  'coach.goal.oversteer.adj5.param': 'Presión de neumáticos traseros',
  'coach.goal.oversteer.adj5.change': 'Reducir ligeramente',
  'coach.goal.oversteer.adj5.effect': 'Mayor huella de contacto trasera',
  'coach.goal.oversteer.adj5.side': 'Calentamiento más lento del neumático',
  'coach.goal.oversteer.adj6.param': 'Barra de torsión delantera',
  'coach.goal.oversteer.adj6.change': 'Añadir',
  'coach.goal.oversteer.adj6.effect': 'Endurece el tren delantero, reduce el agarre delantero',
  'coach.goal.oversteer.adj6.side': 'Menor absorción delantera',

  // Chassis Bounce
  'coach.goal.bounce.title': 'El chasis rebota en las curvas',
  'coach.goal.bounce.desc': 'El chasis salta o rebota en las curvas en lugar de mantener un contacto uniforme con la pista. Suele deberse a un chasis demasiado rígido en relación con el nivel de agarre, impidiendo mantener una velocidad constante en curva.',
  'coach.goal.bounce.adj1.param': 'Eje trasero',
  'coach.goal.bounce.adj1.change': 'Más blando (menos rígido)',
  'coach.goal.bounce.adj1.effect': 'Absorbe energía, suaviza el comportamiento',
  'coach.goal.bounce.adj1.side': 'Puede reducir el agarre trasero',
  'coach.goal.bounce.adj2.param': 'Ancho trasero',
  'coach.goal.bounce.adj2.change': 'Ensanchar',
  'coach.goal.bounce.adj2.effect': 'Estabiliza el chasis en la curva',
  'coach.goal.bounce.adj2.side': 'Menor rotación a la salida',
  'coach.goal.bounce.adj3.param': 'Parachoques trasero',
  'coach.goal.bounce.adj3.change': 'Aflojar',
  'coach.goal.bounce.adj3.effect': 'Añade flexión, absorbe vibraciones',
  'coach.goal.bounce.adj3.side': 'Soporte menos rígido',
  'coach.goal.bounce.adj4.param': 'Presión de neumáticos traseros',
  'coach.goal.bounce.adj4.change': 'Reducir',
  'coach.goal.bounce.adj4.effect': 'Mayor absorción sobre baches',
  'coach.goal.bounce.adj4.side': 'Respuesta más lenta',
  'coach.goal.bounce.adj5.param': 'Altura delantera',
  'coach.goal.bounce.adj5.change': 'Subir',
  'coach.goal.bounce.adj5.effect': 'Mayor altura libre del chasis',
  'coach.goal.bounce.adj5.side': 'Menos agarre delantero',

  // Reduce Front Aggressiveness
  'coach.goal.frontAggressive.title': 'Reducir la agresividad delantera',
  'coach.goal.frontAggressive.desc': 'El tren delantero tiene demasiado agarre, haciendo que el kart entre demasiado brusco en la curva y desestabilice la parte trasera. El kart se siente nervioso en la entrada y puede provocar un sobreviraje repentino.',
  'coach.goal.frontAggressive.adj1.param': 'Ancho de vía delantero',
  'coach.goal.frontAggressive.adj1.change': 'Estrechar',
  'coach.goal.frontAggressive.adj1.effect': 'Reduce el agarre delantero',
  'coach.goal.frontAggressive.adj1.side': 'Mayor tendencia al subviraje',
  'coach.goal.frontAggressive.adj2.param': 'Avance delantero (Caster)',
  'coach.goal.frontAggressive.adj2.change': 'Reducir',
  'coach.goal.frontAggressive.adj2.effect': 'Menos mordiente delantero al girar',
  'coach.goal.frontAggressive.adj2.side': 'Entrada en curva más lenta',
  'coach.goal.frontAggressive.adj3.param': 'Barra de torsión delantera',
  'coach.goal.frontAggressive.adj3.change': 'Quitar o ablandar',
  'coach.goal.frontAggressive.adj3.effect': 'Ablanda el tren delantero',
  'coach.goal.frontAggressive.adj3.side': 'El tren delantero puede perder precisión',
  'coach.goal.frontAggressive.adj4.param': 'Caída delantera (Camber)',
  'coach.goal.frontAggressive.adj4.change': 'Reducir (menos negativa)',
  'coach.goal.frontAggressive.adj4.effect': 'Menos agarre en curva',
  'coach.goal.frontAggressive.adj4.side': 'Desgaste de neumáticos más uniforme',
  'coach.goal.frontAggressive.adj5.param': 'Presión de neumáticos delanteros',
  'coach.goal.frontAggressive.adj5.change': 'Aumentar',
  'coach.goal.frontAggressive.adj5.effect': 'Menor huella de contacto',
  'coach.goal.frontAggressive.adj5.side': 'Más directo pero con menos agarre',

  // Reduce Rear Sliding
  'coach.goal.rearSlide.title': 'Reducir el deslizamiento trasero',
  'coach.goal.rearSlide.desc': 'La parte trasera del kart desliza en exceso durante el paso por curva, causando pérdida de tiempo y desgaste excesivo de los neumáticos. Al kart le falta tracción trasera y se siente inestable bajo carga lateral.',
  'coach.goal.rearSlide.adj1.param': 'Eje trasero',
  'coach.goal.rearSlide.adj1.change': 'Endurecer (más rígido)',
  'coach.goal.rearSlide.adj1.effect': 'Más agarre trasero',
  'coach.goal.rearSlide.adj1.side': 'Puede rebotar en los baches',
  'coach.goal.rearSlide.adj2.param': 'Ancho trasero',
  'coach.goal.rearSlide.adj2.change': 'Ensanchar',
  'coach.goal.rearSlide.adj2.effect': 'Más agarre mecánico trasero',
  'coach.goal.rearSlide.adj2.side': 'Rotación menos libre',
  'coach.goal.rearSlide.adj3.param': 'Presión de neumáticos traseros',
  'coach.goal.rearSlide.adj3.change': 'Aumentar ligeramente',
  'coach.goal.rearSlide.adj3.effect': 'Mejor perfil del neumático bajo carga',
  'coach.goal.rearSlide.adj3.side': 'Menor huella de contacto en situaciones extremas',
  'coach.goal.rearSlide.adj4.param': 'Ancho de vía delantero',
  'coach.goal.rearSlide.adj4.change': 'Estrechar',
  'coach.goal.rearSlide.adj4.effect': 'Equilibra la distribución de agarre',
  'coach.goal.rearSlide.adj4.side': 'Menos mordiente delantero',
  'coach.goal.rearSlide.adj5.param': 'Bujes traseros',
  'coach.goal.rearSlide.adj5.change': 'Usar más largos/anchos',
  'coach.goal.rearSlide.adj5.effect': 'Mayor palanca trasera',
  'coach.goal.rearSlide.adj5.side': 'Dirección más pesada',

  // Corner Exit Traction
  'coach.goal.cornerExit.title': 'Mejorar la tracción a la salida de curva',
  'coach.goal.cornerExit.desc': 'Al kart le cuesta transmitir la potencia a la salida de las curvas, patinando o deslizando las ruedas traseras al acelerar desde curvas lentas. Esto provoca pérdida de tiempo en la fase de salida hacia la recta.',
  'coach.goal.cornerExit.adj1.param': 'Ancho trasero',
  'coach.goal.cornerExit.adj1.change': 'Ensanchar',
  'coach.goal.cornerExit.adj1.effect': 'Más agarre mecánico a la salida',
  'coach.goal.cornerExit.adj1.side': 'Menor rotación a mitad de curva',
  'coach.goal.cornerExit.adj2.param': 'Eje trasero',
  'coach.goal.cornerExit.adj2.change': 'Endurecer (más rígido)',
  'coach.goal.cornerExit.adj2.effect': 'Asienta la parte trasera al acelerar',
  'coach.goal.cornerExit.adj2.side': 'Puede rebotar bajo carga',
  'coach.goal.cornerExit.adj3.param': 'Presión de neumáticos traseros',
  'coach.goal.cornerExit.adj3.change': 'Bajar',
  'coach.goal.cornerExit.adj3.effect': 'Mayor huella de contacto a la salida',
  'coach.goal.cornerExit.adj3.side': 'Calentamiento más lento del neumático',
  'coach.goal.cornerExit.adj4.param': 'Corona trasera',
  'coach.goal.cornerExit.adj4.change': 'Aumentar (más dientes)',
  'coach.goal.cornerExit.adj4.effect': 'Más par a bajas vueltas',
  'coach.goal.cornerExit.adj4.side': 'Menor velocidad punta',
  'coach.goal.cornerExit.adj5.param': 'Parachoques trasero',
  'coach.goal.cornerExit.adj5.change': 'Aflojar',
  'coach.goal.cornerExit.adj5.effect': 'Más flexión bajo carga',
  'coach.goal.cornerExit.adj5.side': 'Comportamiento menos predecible',

  // Hot Conditions
  'coach.goal.hotConditions.title': 'Adaptarse a condiciones de calor',
  'coach.goal.hotConditions.desc': 'La temperatura de la pista es alta, aumentando el nivel de agarre y sobrecalentando los neumáticos. El chasis puede sentirse con exceso de agarre, provocando rebotes o agresividad delantera. El motor trabaja más caliente y puede necesitar una mezcla más rica.',
  'coach.goal.hotConditions.adj1.param': 'Presión de todos los neumáticos',
  'coach.goal.hotConditions.adj1.change': 'Aumentar',
  'coach.goal.hotConditions.adj1.effect': 'Compensa la expansión por calor',
  'coach.goal.hotConditions.adj1.side': 'Puede reducir el agarre si es excesiva',
  'coach.goal.hotConditions.adj2.param': 'Chiclé de alta',
  'coach.goal.hotConditions.adj2.change': 'Enriquecer (número mayor)',
  'coach.goal.hotConditions.adj2.effect': 'Evita una mezcla demasiado pobre',
  'coach.goal.hotConditions.adj2.side': 'Ligera pérdida de potencia',
  'coach.goal.hotConditions.adj3.param': 'Eje trasero',
  'coach.goal.hotConditions.adj3.change': 'Ablandar',
  'coach.goal.hotConditions.adj3.effect': 'Compensa el aumento de agarre en pista',
  'coach.goal.hotConditions.adj3.side': 'Puede sentirse suelto de atrás',
  'coach.goal.hotConditions.adj4.param': 'Ancho trasero',
  'coach.goal.hotConditions.adj4.change': 'Estrechar ligeramente',
  'coach.goal.hotConditions.adj4.effect': 'Reduce el exceso de agarre trasero',
  'coach.goal.hotConditions.adj4.side': 'Menor tracción a la salida',
  'coach.goal.hotConditions.adj5.param': 'Tornillo de aire',
  'coach.goal.hotConditions.adj5.change': 'Abrir (más vueltas hacia fuera)',
  'coach.goal.hotConditions.adj5.effect': 'Mezcla de ralentí más rica',
  'coach.goal.hotConditions.adj5.side': 'Puede afectar la estabilidad del ralentí',

  // Cold/Wet Conditions
  'coach.goal.coldConditions.title': 'Adaptarse a condiciones de frío / lluvia',
  'coach.goal.coldConditions.desc': 'La temperatura de la pista es baja o el asfalto está mojado, reduciendo los niveles de agarre. El kart necesita el máximo agarre mecánico y la carburación debe compensar el aire más denso. Realiza todos los cambios de forma conservadora y prioriza la seguridad del piloto.',
  'coach.goal.coldConditions.adj1.param': 'Presión de todos los neumáticos',
  'coach.goal.coldConditions.adj1.change': 'Reducir',
  'coach.goal.coldConditions.adj1.effect': 'Compensa la contracción por frío',
  'coach.goal.coldConditions.adj1.side': 'Riesgo de desllantar el neumático',
  'coach.goal.coldConditions.adj2.param': 'Chiclé de alta',
  'coach.goal.coldConditions.adj2.change': 'Empobrecer (número menor)',
  'coach.goal.coldConditions.adj2.effect': 'Compensa el aire más denso',
  'coach.goal.coldConditions.adj2.side': 'Riesgo de sobrecalentar el motor',
  'coach.goal.coldConditions.adj3.param': 'Eje trasero',
  'coach.goal.coldConditions.adj3.change': 'Endurecer (más rígido)',
  'coach.goal.coldConditions.adj3.effect': 'Genera más agarre mecánico',
  'coach.goal.coldConditions.adj3.side': 'Puede rebotar sobre asfalto mojado',
  'coach.goal.coldConditions.adj4.param': 'Ancho delantero y trasero',
  'coach.goal.coldConditions.adj4.change': 'Ensanchar ambos',
  'coach.goal.coldConditions.adj4.effect': 'Maximiza el agarre mecánico',
  'coach.goal.coldConditions.adj4.side': 'Comportamiento más agresivo',
  'coach.goal.coldConditions.adj5.param': 'Tornillo de aire',
  'coach.goal.coldConditions.adj5.change': 'Cerrar (menos vueltas hacia fuera)',
  'coach.goal.coldConditions.adj5.effect': 'Mezcla de ralentí más pobre',
  'coach.goal.coldConditions.adj5.side': 'Puede dificultar el arranque en frío',

  // Braking Stability
  'coach.goal.braking.title': 'Mejorar la estabilidad en frenada',
  'coach.goal.braking.desc': 'El kart es inestable al frenar, cruzándose de atrás o bloqueando de delante. Esto dificulta frenar tarde y con consistencia, perdiendo tiempo en la entrada de las curvas.',
  'coach.goal.braking.adj1.param': 'Presión de neumáticos delanteros',
  'coach.goal.braking.adj1.change': 'Aumentar',
  'coach.goal.braking.adj1.effect': 'Tren delantero más preciso en frenada',
  'coach.goal.braking.adj1.side': 'Menor huella de contacto en frenada',
  'coach.goal.braking.adj2.param': 'Avance delantero (Caster)',
  'coach.goal.braking.adj2.change': 'Aumentar',
  'coach.goal.braking.adj2.effect': 'Mayor avance, estabiliza en frenada',
  'coach.goal.braking.adj2.side': 'Dirección más pesada',
  'coach.goal.braking.adj3.param': 'Altura delantera',
  'coach.goal.braking.adj3.change': 'Bajar',
  'coach.goal.braking.adj3.effect': 'Mayor transferencia de peso delantera',
  'coach.goal.braking.adj3.side': 'Riesgo de tocar fondo con el chasis',
  'coach.goal.braking.adj4.param': 'Barra de torsión delantera',
  'coach.goal.braking.adj4.change': 'Añadir',
  'coach.goal.braking.adj4.effect': 'Endurece el tren delantero en frenada',
  'coach.goal.braking.adj4.side': 'Puede reducir el agarre al entrar en curva',
  'coach.goal.braking.adj5.param': 'Presión de neumáticos traseros',
  'coach.goal.braking.adj5.change': 'Reducir',
  'coach.goal.braking.adj5.effect': 'Evita el bloqueo trasero',
  'coach.goal.braking.adj5.side': 'Respuesta trasera más lenta',

  // Engine Tuning
  'coach.goal.engine.title': 'Ajustar el rendimiento del motor',
  'coach.goal.engine.desc': 'Optimiza el rendimiento del motor mediante ajustes de desarrollo y carburación. Estos cambios afectan la entrega de potencia, aceleración, velocidad punta y fiabilidad del motor. Controla siempre la EGT (temperatura de gases de escape) al modificar la carburación.',
  'coach.goal.engine.adj1.param': 'Corona trasera',
  'coach.goal.engine.adj1.change': 'Aumentar (más dientes)',
  'coach.goal.engine.adj1.effect': 'Más aceleración, menor velocidad punta',
  'coach.goal.engine.adj1.side': 'Mayores RPM en las rectas',
  'coach.goal.engine.adj2.param': 'Corona trasera',
  'coach.goal.engine.adj2.change': 'Disminuir (menos dientes)',
  'coach.goal.engine.adj2.effect': 'Mayor velocidad punta, menos aceleración',
  'coach.goal.engine.adj2.side': 'Menores RPM, salidas de curva más lentas',
  'coach.goal.engine.adj3.param': 'Chiclé de alta',
  'coach.goal.engine.adj3.change': 'Enriquecer (número mayor)',
  'coach.goal.engine.adj3.effect': 'EGT más baja, mayor seguridad',
  'coach.goal.engine.adj3.side': 'Ligera pérdida de potencia',
  'coach.goal.engine.adj4.param': 'Chiclé de alta',
  'coach.goal.engine.adj4.change': 'Empobrecer (número menor)',
  'coach.goal.engine.adj4.effect': 'Más potencia',
  'coach.goal.engine.adj4.side': 'Riesgo de gripaje, EGT más alta',
  'coach.goal.engine.adj5.param': 'Clip de aguja',
  'coach.goal.engine.adj5.change': 'Subir posición',
  'coach.goal.engine.adj5.effect': 'Medio régimen más pobre, más potencia',
  'coach.goal.engine.adj5.side': 'Riesgo de mezcla pobre',
  'coach.goal.engine.adj6.param': 'Altura de flotador',
  'coach.goal.engine.adj6.change': 'Ajustar',
  'coach.goal.engine.adj6.effect': 'Controla el nivel de combustible en la cuba',
  'coach.goal.engine.adj6.side': 'Afecta a todos los rangos de RPM',

  // Track Map Controls
  'trackMap.zoomIn': 'Acercar',
  'trackMap.zoomOut': 'Alejar',
  'trackMap.fitTrack': 'Ajustar circuito',
  'trackMap.satellite': 'Satélite',
  'trackMap.vector': 'Vectorial',
  'trackMap.switchProvider': 'Cambiar proveedor de imágenes aéreas',

  // Lap Analysis Queue & Amended Analysis
  'queue.processingLaps': 'Analizando vueltas {done}/{total}',
  'queue.completed': 'Análisis de vueltas completado ({total}/{total})',
  'tracks.reanalyzeLaps': 'Reanalizar vueltas',
  'tracks.reanalyzingLaps': 'Poniendo en cola…',
  'tracks.reanalyzeQueued': '{enqueued} vuelta(s) en cola para análisis ({skipped} ya actualizadas).',
  'tracks.reanalyzeAllUpToDate': 'Las {skipped} vuelta(s) ya están actualizadas con los datos actuales del circuito.',
  'lapInfo.canonicalSectors': 'Sectores del circuito',
  'lapInfo.loggerSectors': 'Sectores del logger',
  'lapAnalysis.amendedCornersTitle': 'Desglose de curvas y frenada',
  'lapAnalysis.cornerCol': 'Curva',
  'lapAnalysis.topApproachSpeed': 'Vel. máx. antes de frenar',
  'lapAnalysis.slowestSpeed': 'Velocidad mínima',
  'lapAnalysis.apexSpeed': 'Velocidad en el vértice',
  'lapAnalysis.exitSpeed': 'Velocidad de salida',
  'lapAnalysis.brakingDist': 'Dist. de frenada',
  'lapAnalysis.cornerTime': 'Duración',
  'lapAnalysis.statusCompleted': 'Análisis completado',
  'lapAnalysis.statusPending': 'Análisis pendiente',
  'session.tabCorners': 'Curvas',
  'session.noCornersConfigured': 'No hay datos de análisis de curvas disponibles para esta sesión.',
  'lapAnalysis.entrySpeed': 'Velocidad de entrada',
  'lapAnalysis.trailBraking': 'Trail-Braking',

  // Terms & Conditions
  'footer.termsAndConditions': 'Términos y condiciones',
  'terms.gateTitle': 'Términos y condiciones',
  'terms.gateSubtitle': 'Revisa y acepta la última versión de los Términos y condiciones para continuar.',
  'terms.updatedBannerTitle': 'Términos y condiciones actualizados:',
  'terms.updatedBannerDesc': 'Nuestros Términos y condiciones se han actualizado. Revisa y acepta la nueva versión para seguir usando kart.win.',
  'terms.checkboxLabel': 'He leído y acepto los Términos y condiciones',
  'terms.acceptButton': 'Aceptar y continuar',
  'terms.acceptingButton': 'Aceptando…',
  'terms.loadError': 'No se pudieron cargar los Términos y condiciones. Comprueba tu conexión e inténtalo de nuevo.',
  'terms.acceptError': 'No se pudo registrar tu aceptación. Inténtalo de nuevo.',

  // Additional Common & Import Keys
  'common.previous': 'Anterior',
  'common.remove': 'Eliminar',
  'common.success': 'Guardado correctamente',
  'common.failedToSave': 'Error al guardar',
  'import.useCurrentSetupDesc': 'Asociar la configuración activa del kart con las sesiones importadas.',

  // Search & Filter Bar
  'search.booleanLogicUse': 'Combina términos con',
  'search.booleanLogicOr': 'o',
  'search.booleanLogicGroup': 'y agrupa expresiones con paréntesis',
  'filter.operator.eq': 'es',
  'filter.operator.neq': 'no es',
  'filter.operator.gt': 'mayor que',
  'filter.operator.gte': 'al menos',
  'filter.operator.lt': 'menor que',
  'filter.operator.lte': 'como máximo',
  'filter.operator.range': 'entre',
  'filter.operator.contains': 'contiene',
  'filter.remove': 'Eliminar filtro',
  'filter.done': 'Listo',
  'filter.clearInput': 'Limpiar entrada',
  'filter.selectField': 'Filtrar por campo',
  'filter.pressEnter': 'Pulsa Intro para aplicar',
  'filter.selectValues': 'Seleccionar valores',
  'filter.noMatchingOptions': 'Sin opciones coincidentes',

  // Search Schemas
  'filter.session.bareSearchExample': 'Buscar por nombre de circuito',
  'filter.session.searchTrack': 'Filtrar por nombre de circuito',
  'filter.session.filterLaps': 'Filtrar por número total de vueltas',
  'filter.session.filterBestTime': 'Filtrar por mejor tiempo de vuelta (segundos)',
  'filter.session.filterMaxSpeed': 'Filtrar por velocidad máxima (km/h)',
  'filter.session.filterMaxRpm': 'Filtrar por RPM máximas del motor',
  'filter.session.filterDate': 'Filtrar por fecha de sesión',
  'filter.session.filterShared': 'Filtrar por estado de uso compartido en equipo',
  'filter.session.filterVisibility': 'Filtrar por propiedad o visibilidad del equipo',
  'filter.session.visibilityMine': 'Mis sesiones',
  'filter.session.visibilityShared': 'Compartidas con el equipo',
  'filter.session.exampleTrackLaps': 'Sesiones en Lonato con 10+ vueltas',
  'filter.session.exampleBestSpeed': 'Vueltas rápidas con alta velocidad punta',

  'filter.analysis.bareSearchExample': 'Buscar por título de análisis o nombre de circuito',
  'filter.analysis.searchTitle': 'Filtrar por título de análisis',
  'filter.analysis.searchTrack': 'Filtrar por nombre de circuito',
  'filter.analysis.filterType': 'Filtrar por tipo de análisis',
  'filter.analysis.filterDate': 'Filtrar por fecha de creación',
  'filter.analysis.filterShared': 'Filtrar por estado compartido en equipo',
  'filter.analysis.filterVisibility': 'Filtrar por propiedad o equipo',
  'filter.analysis.exampleCornerTrack': 'Análisis de curvas en Lonato',
  'filter.analysis.exampleSharedDate': 'Análisis compartidos de 2026',

  'filter.trackRaces.bareSearchExample': 'Buscar por título de evento, temporada o categoría',
  'filter.trackRaces.searchTitle': 'Filtrar por título del evento',
  'filter.trackRaces.searchSeason': 'Filtrar por temporada de campeonato',
  'filter.trackRaces.searchCategory': 'Filtrar por categoría de competición',
  'filter.trackRaces.filterRound': 'Filtrar por número de ronda',
  'filter.trackRaces.filterDate': 'Filtrar por fecha del evento',
  'filter.trackRaces.exampleCatDate': 'Eventos ROK Mini en 2026',
  'filter.trackRaces.exampleSeasonRound': 'Dos primeras rondas de la ROK Cup',

  'filter.tracks.bareSearchExample': 'Buscar por nombre de circuito o país',
  'filter.tracks.searchName': 'Filtrar por nombre de circuito',
  'filter.tracks.searchCountry': 'Filtrar por código de país',
  'filter.tracks.filterType': 'Filtrar por origen del circuito (oficial o medido)',
  'filter.tracks.filterSessions': 'Filtrar por número de sesiones registradas',
  'filter.tracks.filterLaps': 'Filtrar por número de vueltas registradas',
  'filter.tracks.filterEvents': 'Filtrar por número de eventos oficiales',
  'filter.tracks.filterDrivers': 'Filtrar por número de pilotos oficiales',
  'filter.tracks.exampleItSessions': 'Circuitos italianos con sesiones registradas',
  'filter.tracks.exampleOfficialEvents': 'Circuitos oficiales con 3+ eventos',

  'filter.leaderboard.bareSearchExample': 'Buscar por piloto, categoría, temporada o evento',
  'filter.leaderboard.searchDriver': 'Filtrar por nombre del piloto',
  'filter.leaderboard.searchCategory': 'Filtrar por categoría de competición',
  'filter.leaderboard.searchSeason': 'Filtrar por temporada de campeonato',
  'filter.leaderboard.searchEvent': 'Filtrar por nombre del evento',
  'filter.leaderboard.filterLapTime': 'Filtrar por tiempo de vuelta (segundos)',
  'filter.leaderboard.filterSpeed': 'Filtrar por velocidad punta (km/h)',
  'filter.leaderboard.filterRpm': 'Filtrar por RPM máximas',
  'filter.leaderboard.filterDate': 'Filtrar por fecha de vuelta',
  'filter.leaderboard.exampleTimeSpeed': 'Vueltas por debajo de 48 s con alta velocidad punta',
  'filter.leaderboard.exampleCatTime': 'Vueltas categoría Mini entre 52 s y 54 s',

  'filter.tyres.bareSearchExample': 'Buscar por nombre de juego, marca, modelo o código de barras',
  'filter.tyres.searchName': 'Filtrar por nombre del juego de neumáticos',
  'filter.tyres.searchBrand': 'Filtrar por marca de neumáticos',
  'filter.tyres.searchModel': 'Filtrar por compuesto/modelo de neumáticos',
  'filter.tyres.searchSize': 'Filtrar por medida de neumáticos',
  'filter.tyres.searchBarcode': 'Filtrar por código de barras escaneado',
  'filter.tyres.filterStatus': 'Filtrar por estado del ciclo de vida',
  'filter.tyres.filterCondition': 'Filtrar por estado restante (%)',
  'filter.tyres.filterLaps': 'Filtrar por total de vueltas recorridas',
  'filter.tyres.filterDistance': 'Filtrar por distancia total recorrida (km)',
  'filter.tyres.exampleActiveBrand': 'Juegos de neumáticos LeCont activos',
  'filter.tyres.exampleConditionLaps': 'Neumáticos con >50 % de vida y <30 vueltas',

  'filter.teamMembers.bareSearchExample': 'Buscar por nombre o correo del miembro',
  'filter.teamMembers.searchName': 'Filtrar por nombre del miembro',
  'filter.teamMembers.searchEmail': 'Filtrar por correo del miembro',
  'filter.teamMembers.filterRole': 'Filtrar por rol en el equipo',
  'filter.teamMembers.exampleRoleAdmin': 'Administradores del equipo',
  'filter.teamMembers.exampleNameRole': 'Miembros o editores por nombre',

  'filter.teamSharing.bareSearchExample': 'Buscar por título, propietario o circuito',
  'filter.teamSharing.searchTitle': 'Filtrar por título del elemento',
  'filter.teamSharing.searchOwner': 'Filtrar por nombre del propietario',
  'filter.teamSharing.searchTrack': 'Filtrar por nombre de circuito',
  'filter.teamSharing.filterKind': 'Filtrar por tipo de elemento compartido',
  'filter.teamSharing.kindSession': 'Sesión',
  'filter.teamSharing.kindAnalysis': 'Análisis',
  'filter.teamSharing.filterAccess': 'Filtrar por permiso de acceso',
  'filter.teamSharing.accessRead': 'Solo lectura',
  'filter.teamSharing.accessWrite': 'Lectura y escritura',
  'filter.teamSharing.exampleSessionTrack': 'Sesiones compartidas de Lonato',
  'filter.teamSharing.exampleAnalysisWrite': 'Análisis compartidos editables',

  'filter.drivers.bareSearchExample': 'Buscar por nombre de piloto, equipo, categoría o material',
  'filter.drivers.searchName': 'Filtrar por nombre del piloto',
  'filter.drivers.searchCountry': 'Filtrar por código de nacionalidad',
  'filter.drivers.searchTeam': 'Filtrar por equipo',
  'filter.drivers.searchCategory': 'Filtrar por categoría',
  'filter.drivers.searchChassis': 'Filtrar por marca de chasis',
  'filter.drivers.searchEngine': 'Filtrar por marca de motor',
  'filter.drivers.filterEntries': 'Filtrar por número de participaciones',
  'filter.drivers.exampleCountryEntries': 'Pilotos italianos con 5+ participaciones',
  'filter.drivers.exampleCatTeam': 'Pilotos Mini de un equipo específico',

  'filter.driverHistory.bareSearchExample': 'Buscar por temporada, evento, circuito o categoría',
  'filter.driverHistory.searchSeason': 'Filtrar por temporada de campeonato',
  'filter.driverHistory.searchEvent': 'Filtrar por nombre del evento',
  'filter.driverHistory.searchTrack': 'Filtrar por nombre del circuito',
  'filter.driverHistory.searchCategory': 'Filtrar por categoría',
  'filter.driverHistory.searchTeam': 'Filtrar por nombre del equipo',
  'filter.driverHistory.filterPos': 'Filtrar por posición final',
  'filter.driverHistory.filterGrid': 'Filtrar por posición de parrilla',
  'filter.driverHistory.filterPoints': 'Filtrar por puntos obtenidos',
  'filter.driverHistory.filterBestLap': 'Filtrar por vuelta rápida (segundos)',
  'filter.driverHistory.filterPenalties': 'Filtrar por número de sanciones',
  'filter.driverHistory.examplePodiums': 'Podios (Top 3)',
  'filter.driverHistory.examplePointsPenalty': 'Eventos con muchos puntos sin sanciones',

  // Additional Analysis & Component Keys
  'braking.colSelect': 'Sel',
  'braking.colCompare': 'Cmp',
  'braking.scoreUnit': '/ 100',
  'braking.trackOverview': 'Resumen del circuito',
  'braking.cornersCount': '{count} curvas',
  'braking.trackAnalysis': 'Análisis de frenada del circuito',
  'braking.lapsTotal': '{count} vueltas en total',
  'braking.sample': 'Muestra',
  'lapdiff.pointDetail': 'Detalle del punto',
  'lapdiff.selectTwoLaps': 'Seleccionar 2 vueltas',
  'lapdiff.lapTime': 'Tiempo de vuelta',
  'aggregationdiff.toggleLayers': 'Alternar capas del mapa',
  'aggregationdiff.leftInner': 'Izquierda (Interior)',
  'aggregationdiff.rightOuter': 'Derecha (Exterior)',
  'aggregationdiff.selectLap': 'Seleccionar una vuelta',
  'aggregationdiff.modeSingleLap': 'Vuelta única',
  'aggregationdiff.modeSessions': 'Sesiones',
  'braking.phaseBraking': 'Frenada',
  'braking.phaseAccel': 'Aceleración',
  'setup.tabFront': 'Delantero',
  'setup.tabRear': 'Trasero',
  'team.you': 'Tú',
  'races.entries': 'Inscritos',
  // Filter Schema & UI Translations
  'filter.filterBy': 'Filtrar por {label}',
  'filter.removeFilter': 'Eliminar filtro {label}',
  'filter.prevMonth': 'Mes anterior',
  'filter.nextMonth': 'Mes siguiente',
  'filter.selectStartDate': 'Selecciona la fecha de inicio en el calendario',
  'filter.op.exact': 'Exacto',
  'filter.op.atLeast': 'Al menos',
  'filter.op.atMost': 'Como máximo',
  'filter.op.between': 'Entre',
  'filter.op.greater': 'Mayor',
  'filter.op.less': 'Menor',
  'filter.preset.today': 'Hoy',
  'filter.preset.last7d': 'Últimos 7 días',
  'filter.preset.last30d': 'Últimos 30 días',
  'filter.preset.last90d': 'Últimos 90 días',
  'filter.preset.last1y': 'Último año',
  'filter.preset.last7dShort': 'Últimos 7d',
  'filter.preset.last30dShort': 'Últimos 30d',
  'filter.preset.last90dShort': 'Últimos 90d',
  'filter.preset.last1yShort': 'Último 1a',
  'filter.sessionType.race': 'Carrera',
  'filter.sessionType.final': 'Final',
  'filter.sessionType.pre_final': 'Prefinal',
  'filter.sessionType.heat': 'Manga',
  'filter.sessionType.qualifying': 'Clasificación',
  'filter.unit.laps': 'vueltas',
  'filter.schema.tyres.title': 'Sintaxis de búsqueda de neumáticos',
  'filter.schema.tyres.subtitle': 'Filtra neumáticos por marca, compuesto, uso, código de barras, circuito o estado descartado.',
  'filter.field.brand': 'Marca',
  'filter.desc.brand': 'Fabricante de neumáticos (Mojo, Vega, LeCont, Bridgestone, etc.)',
  'filter.field.tyreModel': 'Modelo de neumático',
  'filter.placeholder.tyreModel': 'p. ej. D2, D5, W5, CIK Option',
  'filter.desc.tyreModel': 'Nombre del modelo o especificación del compuesto',
  'filter.field.compound': 'Compuesto',
  'filter.desc.compound': 'Categoría de compuesto (seco, mojado, slick, lluvia)',
  'filter.compound.dry': 'Seco',
  'filter.compound.wet': 'Mojado',
  'filter.compound.slick': 'Slick',
  'filter.compound.rain': 'Lluvia',
  'filter.field.setNumber': 'Número de juego',
  'filter.desc.setNumber': 'Número de juego de neumáticos asignado en el inventario',
  'filter.field.totalLaps': 'Vueltas totales',
  'filter.desc.totalLaps': 'Total acumulado de vueltas recorridas con este juego de neumáticos',
  'filter.preset.tyreFresh': 'Nuevo (0..15 vueltas)',
  'filter.preset.tyreBrokenIn': 'Rodado (16..50 vueltas)',
  'filter.preset.tyreHighMileage': 'Alto kilometraje (> 50 vueltas)',
  'filter.field.barcode': 'Código de barras',
  'filter.placeholder.barcode': 'Código de barras DI, DD, TI, TD',
  'filter.desc.barcode': 'Coincidencia parcial en cualquier código de barras del juego',
  'filter.field.lastTrack': 'Último circuito',
  'filter.desc.lastTrack': 'Último circuito donde se usó este juego de neumáticos',
  'filter.field.discarded': 'Descartados',
  'filter.desc.discarded': 'Indica si el juego de neumáticos se ha marcado como descartado',
  'filter.discarded.false': 'No',
  'filter.discarded.true': 'Sí',
  'filter.example.activeTyres': 'Juegos de neumáticos activos (no descartados)',
  'filter.example.dryMojo': 'Neumáticos de seco Mojo',
  'filter.example.highMileage70': 'Juegos de neumáticos con más de 70 vueltas',
  'filter.example.freshTyres': 'Neumáticos nuevos / bajo kilometraje',
  'filter.example.lonatoTyres': 'Neumáticos usados en Lonato desde agosto de 2026',
  'filter.example.vegaOrWet': 'Juegos Vega o cualquier neumático de lluvia',
  'filter.field.date': 'Fecha',
  'filter.desc.date': 'Filtrar por periodo relativo (-7d, -30d, today) o rango de fechas del calendario',
  'filter.field.track': 'Circuito',
  'filter.desc.track': 'Coincide con el nombre del circuito',
  'filter.placeholder.track': 'p. ej. Wohlen, Lonato',
  'filter.field.driver': 'Piloto',
  'filter.desc.driver': 'Coincide con el nombre del piloto',
  'filter.placeholder.driver': 'p. ej. Yanick',
  'filter.field.season': 'Temporada',
  'filter.desc.season': 'Coincide con el año de la temporada',
  'filter.field.category': 'Categoría',
  'filter.desc.category': 'Categoría de carrera canónica',
  'filter.field.championship': 'Campeonato',
  'filter.desc.championship': 'Nombre del campeonato',
  'filter.field.sessionType': 'Tipo de sesión',
  'filter.desc.sessionType': 'Clasificación de sesión (carrera, manga, clasificación, final)',
  'filter.field.position': 'Posición',
  'filter.field.finishPosition': 'Posición final',
  'filter.desc.position': 'Posición final (p. ej. position:<=3 para podios)',
  'filter.preset.posWinner': 'Ganador (P1)',
  'filter.preset.posPodium': 'Podio (≤ P3)',
  'filter.preset.posTop5': 'Top 5 (≤ P5)',
  'filter.preset.posTop10': 'Top 10 (≤ P10)',
  'filter.field.temp': 'Temperatura',
  'filter.desc.temp': 'Temperatura ambiente de la sesión en Celsius (p. ej. temp:15..25)',
  'filter.preset.tempCool': 'Fresco (< 15°C)',
  'filter.preset.tempMild': 'Templado (15..25°C)',
  'filter.preset.tempWarm': 'Cálido (≥ 25°C)',
  'filter.field.laps': 'Vueltas',
  'filter.desc.laps': 'Coincide con el número de vueltas completadas (p. ej. laps:>=5, laps:5..20)',
  'filter.preset.lapsShort': 'Corta (≤ 5 vueltas)',
  'filter.preset.lapsMedium': 'Media (6..15 vueltas)',
  'filter.preset.lapsLong': 'Larga (> 15 vueltas)',
  'analysis.sector': 'Análisis de sectores',
  'analysis.corner': 'Velocidad en curva',
  'analysis.braking': 'Análisis de frenada',
  'analysis.lapdiff': 'Comparación de vueltas',
  'analysis.aggregation': 'Agregación',
  'analysis.aggregationdiff': 'Comparación de agregación',
  'filter.schema.analyses.title': 'Sintaxis de búsqueda de análisis',
  'filter.schema.analyses.subtitle': 'Filtra el historial de análisis mediante claves estructuradas o palabras clave.',
  'filter.field.nameTrack': 'Nombre / Circuito',
  'filter.placeholder.nameTrack': 'p. ej. Sarno, Tanda personalizada',
  'filter.desc.nameTrack': 'Coincide con el nombre del análisis o del circuito (coincidencia parcial)',
  'filter.field.toolType': 'Tipo de herramienta',
  'filter.placeholder.toolType': 'p. ej. sector, corner, lapdiff, aggregation, aggregationdiff',
  'filter.desc.toolType': 'Filtrar por tipo de herramienta de análisis (sector, corner, lapdiff, aggregation, aggregationdiff)',
  'filter.example.sarnoSector': 'Análisis de sectores en Sarno',
  'filter.example.lapdiff30d': 'Comparaciones de vueltas de los últimos 30 días',
  'filter.example.wohlenCorner': 'Análisis de curvas en Wohlen o Mirecourt',
  'filter.schema.sessions.title': 'Sintaxis de búsqueda de sesiones',
  'filter.schema.sessions.subtitle': 'Filtra sesiones mediante claves estructuradas o palabras clave.',
  'filter.field.trackDriver': 'Circuito / Piloto',
  'filter.placeholder.trackDriver': 'p. ej. Wohlen, Mirecourt',
  'filter.desc.trackDriver': 'Coincide con el nombre del circuito o del piloto (coincidencia parcial)',
  'filter.schema.driverHistory.title': 'Sintaxis de búsqueda del historial del piloto',
  'filter.schema.driverHistory.subtitle': 'Filtra el historial de carreras por circuito, campeonato, categoría, tipo de sesión, posición o temporada.',
  'filter.example.podiumWohlen': 'Podios en Wohlen',
  'filter.example.dd2Races2026': 'Carreras de DD2 en 2026',
  'filter.example.victoriesLast1y': 'Victorias en el último año',
  'filter.schema.driversList.title': 'Sintaxis de búsqueda de pilotos',
  'filter.schema.driversList.subtitle': 'Filtra pilotos por nombre, temporada activa, categoría o fecha de participación.',
  'filter.field.driverName': 'Nombre del piloto',
  'filter.placeholder.driverName': 'p. ej. Yanick, Senn',
  'filter.desc.driverName': 'Coincide con el nombre o apellido del piloto',
  'filter.example.findDriverYanick': 'Buscar pilotos que coincidan con Yanick',
  'filter.example.activeDd22026': 'Pilotos activos de DD2 en 2026',
  'filter.example.driversLast90d': 'Pilotos que compitieron en los últimos 90 días',
  'filter.schema.teamMembers.title': 'Sintaxis de búsqueda de miembros del equipo',
  'filter.schema.teamMembers.subtitle': 'Filtra miembros del equipo por nombre, rol o correo electrónico.',
  'filter.field.memberName': 'Nombre del miembro',
  'filter.placeholder.memberName': 'p. ej. Yanick, Alice',
  'filter.desc.memberName': 'Coincide con el nombre visible del miembro',
  'filter.field.role': 'Rol',
  'filter.desc.role': 'Nivel de permisos (admin, gestionar, lectura)',
  'team.role.admin': 'Admin',
  'filter.field.email': 'Correo electrónico',
  'filter.placeholder.email': 'p. ej. gmail.com',
  'filter.desc.email': 'Coincide con la dirección de correo electrónico',
  'filter.example.findMemberYanick': 'Buscar miembros que coincidan con Yanick',
  'filter.example.findTeamAdmins': 'Buscar administradores del equipo',
  'filter.example.findTeamManage': 'Buscar miembros con permisos de gestión',
  'filter.schema.teamSharing.title': 'Sintaxis de búsqueda de recursos compartidos',
  'filter.schema.teamSharing.subtitle': 'Filtra accesos compartidos por propietario, tipo de uso compartido o nivel de permiso.',
  'filter.field.ownerName': 'Propietario / Nombre',
  'filter.desc.ownerName': 'Coincide con el nombre del propietario',
  'filter.field.shareScope': 'Alcance compartido',
  'filter.desc.shareScope': 'Tipo de alcance compartido (todos los datos, sesión única, circuito específico)',
  'filter.shareScope.all': 'Toda la telemetría',
  'filter.shareScope.single': 'Sesión única',
  'filter.shareScope.track': 'Circuito específico',
  'filter.example.sharesYanick': 'Buscar recursos compartidos de Yanick',
  'filter.example.sharesAllRead': 'Recursos compartidos de telemetría completa de solo lectura',
  'filter.schema.trackLeaderboard.title': 'Sintaxis de búsqueda de clasificación del circuito',
  'filter.schema.trackLeaderboard.subtitle': 'Filtra vueltas y sesiones de la clasificación por piloto, temporada, categoría, posición o temperatura.',
  'filter.example.yanickFastest2026': 'Vueltas más rápidas de Yanick en la temporada 2026',
  'filter.example.podiumSeniorMax': 'Podios en Senior MAX',
  'filter.example.warm90d': 'Sesiones con clima cálido en los últimos 90 días',
  'filter.schema.trackRaceEvents.title': 'Sintaxis de búsqueda de eventos de carrera',
  'filter.schema.trackRaceEvents.subtitle': 'Filtra eventos de carrera por temporada, campeonato, categoría o piloto participante.',
  'filter.desc.driverEvent': 'Coincide con un piloto participante en el evento',
  'filter.example.rmc2026': 'Eventos RMC Switzerland 2026',
  'filter.example.yanick2025': 'Eventos en los que participó Yanick en 2025',
  'filter.example.dd2Last1y': 'Eventos de DD2 en el último año',
  'filter.schema.tracks.title': 'Sintaxis de búsqueda de circuitos',
  'filter.schema.tracks.subtitle': 'Filtra circuitos por nombre o palabras clave.',
  'filter.field.trackName': 'Nombre del circuito',
  'filter.example.findWohlen': 'Buscar circuitos que coincidan con Wohlen',
  'filter.example.exactTrack': 'Coincidencia exacta del nombre del circuito',
};
